
import { forEach } from 'lodash-es';
import { WidgetPropertiesProvider } from '@wms/design-container';
import { containerSubGroup } from "@wms/app/design-container/content/layout/containers/config";

import { WidgetDetailedInfo } from '../registerWidgets';
import {deviceSubGroup} from "@wms/app/design-container/content/device/config";

export const widgetsConfig: { [key: string]: WidgetDetailedInfo } = {
  'wm-anchor': {
    "widgetType": "wm-anchor",
    "template": "<wm-anchor margin='unset 0.5em'></wm-anchor>",
    "platforms": {
      "native_mobile": {
        "template": "<wm-anchor margin='unset 4px'></wm-anchor>"
      }
    },
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "anchor",
    styleWorkspaceTemplates: {
      usageTemplate: `<wm-layoutgrid name="layoutgrid">
    <wm-gridrow name="g">
        <wm-gridcolumn columnwidth="2" name="gr">
            <wm-label padding="unset" class="p" type="p" caption="Type" fontweight="bold">
            </wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gri" horizontalalign="center">
            <wm-label padding="unset" class="p" type="p" caption="caption + Image"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="grid" horizontalalign="center">
            <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Left">
            </wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridc" horizontalalign="center">
            <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Right">
            </wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridco" horizontalalign="center">
            <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Top">
            </wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcol">
        <wm-label padding="unset" class="p" type="p" caption="Badge">
            </wm-label></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="grid3e">
        <wm-gridcolumn columnwidth="2" name="gridemwk">
            <wm-label padding="unset" class="p" type="p" caption="default" ></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcolumn120" horizontalalign="center">
        <wm-anchor margin="unset 0.5em" name="anchor4" iconurl="resources/images/imagelists/default-image.png">
        </wm-anchor>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcolumn130" horizontalalign="center">
            <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="left">
            </wm-anchor>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcolumn170" horizontalalign="center">
            <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="right">
            </wm-anchor>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcolumn180" horizontalalign="center">
            <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="top">
            </wm-anchor>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="2" name="gridcolumn140">
        <wm-anchor margin="unset 0.5em" badgevalue="90"></wm-anchor>
        </wm-gridcolumn>
    </wm-gridrow>
                         </wm-layoutgrid>`,
      
      platforms: {
        native_mobile: {
          usageTemplate: `<wm-layoutgrid name="layoutgrid">
        <wm-gridrow name="g">
            <wm-gridcolumn columnwidth="2" name="gr">
                <wm-label padding="unset" class="p" type="p" caption="Type" fontweight="bold">
                </wm-label>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gri" horizontalalign="center">
                <wm-label padding="unset" class="p" type="p" caption="only-caption"></wm-label>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="grid" horizontalalign="center">
                <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Left">
                </wm-label>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridc" horizontalalign="center">
                <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Right">
                </wm-label>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridco" horizontalalign="center">
                <wm-label padding="unset" class="p" type="p" caption="Caption + Icon Top">
                </wm-label>
            </wm-gridcolumn>
        </wm-gridrow>
        <wm-gridrow name="grid3e">
            <wm-gridcolumn columnwidth="2" name="gridemwk">
                <wm-label padding="unset" class="p" type="p" caption="default" ></wm-label>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridcolumn120" horizontalalign="center">
                <wm-anchor margin="unset 0.5em"></wm-anchor>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridcolumn130" horizontalalign="center">
                <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="left">
                </wm-anchor>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridcolumn170" horizontalalign="center">
                <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="right">
                </wm-anchor>
            </wm-gridcolumn>
            <wm-gridcolumn columnwidth="2" name="gridcolumn180" horizontalalign="center">
                <wm-anchor margin="unset 0.5em" iconclass="wi wi-account-circle" iconposition="top">
                </wm-anchor>
            </wm-gridcolumn>
        </wm-gridrow>
                             </wm-layoutgrid>`
        }
      }
    }
  },
  'wm-button': {
    widgetType: "wm-button",
    template: "<wm-button class='btn-default' caption='Button' type='button' margin='unset'></wm-button>",
    platforms: {
      native_mobile: {
        template: "<wm-button class='btn-default' caption='Button' type='button'></wm-button>"
      }
    },
    isContainer: false,
    isResizable: true,
    tokenFileName:"button",
    isMovableInsideCanvas: true,
    isLayoutBundled: true,
    isDroppable: false,
    isDeletable: true,
    canBeCopied: true, 
    styleWorkspaceTemplates : { 
      customTemplate : [`<wm-button class='btn-default' caption='Button' type='button' margin='unset'></wm-button>`, `<wm-button type="button" iconclass="wi wi-share fa-2x"></wm-button>`,`<wm-button type="button" caption="Button" iconclass="wi wi-share fa-2x" class="btn-default"></wm-button>`],
      platforms: {
        native_mobile: {
          usageTemplate: `<wm-layoutgrid name="layoutgrid1">
      <wm-gridrow name="gridrow4" class="align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn10">
              <wm-label class="p fw-medium" type="p" caption="Caption" name="label3"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn11" horizontalalign="center">
              <wm-label class="p" type="p" caption="Only Caption" name="label4"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn12" horizontalalign="center">
              <wm-label class="p" type="p" caption="Caption + Icon Left" name="label5"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn13" horizontalalign="center">
              <wm-label class="p" type="p" caption="Caption + Icon Right" name="label6"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn14" horizontalalign="center">
              <wm-label class="p" type="p" caption="Caption + Icon Top" name="label7"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow14" class="align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn75">
              <wm-label class="p" type="p" caption="" name="label22_1"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn76" horizontalalign="center">
              <wm-button class="btn-filled-primary" caption="Caption" type="button" margin="unset" iconclass=""
                  name="button42"></wm-button>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn77" horizontalalign="center">
              <wm-button class="btn-filled-primary" caption="Caption" type="button" margin="unset" name="button2"
                  iconclass="wi wi-add">
              </wm-button>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn78" horizontalalign="center">
              <wm-button class="btn-filled-primary" caption="Caption" type="button" margin="unset"
                  iconclass="wi wi-add" name="button33" iconposition="right"></wm-button>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn79" horizontalalign="center">
              <wm-button class="btn-filled-primary" caption="Caption" type="button" margin="unset"
                  iconclass="wi wi-add" iconposition="top" name="button37"></wm-button>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow5" class="align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn10">
              <wm-label class="p fw-medium" type="p" caption="Icon & Badge" name="label10"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn11" horizontalalign="center">
              <wm-label class="p" type="p" caption="Only Icon" name="label11"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn12" horizontalalign="center">
              <wm-label class="p" type="p" caption="Only Icon(btn-icon)" name="label12"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn15"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow15" class="align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn81">
              <wm-label class="p" type="p" caption="" name="label23"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn82" horizontalalign="center">
              <wm-button class="btn-filled-primary" caption="" type="button" margin="unset" iconclass="wi wi-add"
                  name="button51" iconposition="top"></wm-button>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn83" horizontalalign="center">
              <wm-button class="btn-filled-primary btn-icon" caption="" type="button" margin="unset"
                  iconclass="wi wi-add" iconposition="top" name="button53_1"></wm-button>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn86"></wm-gridcolumn>
      </wm-gridrow>
      </wm-layoutgrid>`,
        }
      }
    }
  },
  'wm-label': {
    "widgetType": "wm-label",
    "template": "<wm-label padding='unset' caption='label' class='p' type='p'></wm-label>",
    "platforms": {
      "native_mobile": {
        "template": "<wm-label caption='label' padding='unset'></wm-label>"
      }
    },
    "tokenFileName": "label",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "isLayoutBundled": true
  },
  'wm-form-field': {
    "widgetType": "wm-form-field",
    "template": "<wm-form-field></wm-form-field>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls",
     "styleWorkspaceTemplates":{
       platforms: {
        native_mobile: {
          customTemplate:[`<wm-layoutgrid name="layoutgrid1">
                <wm-gridrow name="gridrow1">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn1">
                        <wm-label padding="unset" class="h4" type="p" name="label1" caption="1. Caption Position - Left">
                        </wm-label>
                    </wm-gridcolumn>
                </wm-gridrow>
                <wm-gridrow name="gridrow2">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn3">
                        <wm-form errormessage="" captionposition="left"
                            enctype="application/x-www-form-urlencoded" method="post"
                            dataset="bind:Variables.stvformUsecases.dataSet" captionalign="left"
                            name="stvformUsecasesForm1" class="form-input">
                            <wm-layoutgrid columns="3" name="layoutgrid5">
                                <wm-gridrow name="gridrow9">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn11">
                                        <wm-form-field name="text Required" required="true" displayname="Text Required"
                                            show="true" placeholder="Enter text" type="string" key="text Required"
                                            widget="text" inputtype="text" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn12">
                                        <wm-form-field name="text" displayname="Text" show="true"
                                            placeholder="Enter text" type="string" key="text" widget="text"
                                            inputtype="text" readonly="false" validationmessage="please check">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow47">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn13">
                                        <wm-form-field name="number Required" required="true"
                                            displayname="Number Required" show="true" placeholder="Enter Number"
                                            type="string" key="number Required" widget="number" inputtype="number"
                                            readonly="false" textalign="right" validationmessage="asrequired">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn14">
                                        <wm-form-field name="number" displayname="Number" show="true"
                                            placeholder="Enter Number" type="string" key="number" widget="number"
                                            inputtype="number" readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow10">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn16">
                                        <wm-form-field name="textarea" displayname="Textarea" show="true"
                                            placeholder="Place your text" type="string" key="textarea" widget="textarea"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn15">
                                        <wm-form-field name="currency" displayname="Currency" show="true"
                                            placeholder="Enter value" type="string" key="currency" widget="currency"
                                            readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow111">
                                        <wm-gridcolumn columnwidth="6" name="gridcolumn21">
                                        <wm-form-field name="Select" displayname="Select" show="true" placeholder=""
                                            type="string" key="Select" widget="select" readonly="false"
                                            dataset="yes, no, maybe"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn22">
                                        <wm-form-field name="Autocomplete" displayname="Autocomplete"
                                            matchmode="startignorecase" show="true" placeholder="Search" type="string"
                                            key="Autocomplete" widget="autocomplete" readonly="false"
                                            dataset="yes, no, maybe"></wm-form-field>
                                    </wm-gridcolumn>
                                        
                                </wm-gridrow>
                                <wm-gridrow name="gridrow13">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn23">
                                        <wm-form-field name="time" displayname="Time" show="true"
                                            placeholder="Select time" type="string" key="time" widget="time"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn25">
                                        <wm-form-field name="timestamp" displayname="Timestamp" show="true"
                                            placeholder="Select date time" type="string" key="timestamp"
                                            widget="timestamp" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow14">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn24">
                                        <wm-form-field name="date" displayname="Date" show="true"
                                            placeholder="Select date" type="string" key="date" widget="date"
                                            datepattern="MMM d, y" outputformat="yyyy-MM-dd" readonly="false">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn26">
                                        <wm-form-field name="datetime" displayname="Datetime" show="true"
                                            placeholder="Select date time" type="string" key="datetime"
                                            widget="datetime" datepattern="MMM d, y h:mm:ss a" outputformat="timestamp"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow16">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn34">
                                        <wm-form-field name="password" displayname="Password" show="true"
                                            placeholder="Enter text" type="string" key="password" widget="password"
                                            inputtype="password" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn33">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                            </wm-layoutgrid>
                        </wm-form>
                    </wm-gridcolumn>
                </wm-gridrow>
            </wm-layoutgrid>
            <wm-layoutgrid name="layoutgrid1">
                <wm-gridrow name="gridrow1">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn1">
                        <wm-label padding="unset" class="h4" type="p" name="label1" caption="2. Caption Position - Top">
                        </wm-label>
                    </wm-gridcolumn>
                </wm-gridrow>
                <wm-gridrow name="gridrow2">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn3">
                        <wm-form errormessage="" captionposition="top"
                            enctype="application/x-www-form-urlencoded" method="post"
                            dataset="bind:Variables.stvformUsecases.dataSet" captionalign="left"
                            name="stvformUsecasesForm1" class="form-input">
                            <wm-layoutgrid columns="3" name="layoutgrid5">
                                <wm-gridrow name="gridrow9">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn11">
                                        <wm-form-field readonly="false" name="text Required" displayname="Text Required" required="true"
                                            key="text Required" type="string" show="true" widget="text"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn12">
                                        <wm-form-field readonly="false" name="text" displayname="Text" key="text"
                                            type="string" show="true" widget="text"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow99">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn13">
                                        <wm-form-field readonly="false" name="number Required"
                                            displayname="Number Required" key="number Required" type="string" required="true"
                                            show="true" widget="number" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn14">
                                        <wm-form-field readonly="false" name="number" displayname="Number" key="number"
                                            type="string" show="true" widget="number" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow10">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn16">
                                        <wm-form-field readonly="false" name="textarea" displayname="Textarea"
                                            key="textarea" type="string" show="true" widget="textarea"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn15">
                                        <wm-form-field readonly="false" name="currency" displayname="Currency"
                                            key="currency" type="string" show="true" widget="currency"
                                            textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow101">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn21">
                                        <wm-form-field readonly="false" name="Select" displayname="Select" key="Select"
                                            type="string" show="true" widget="select"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn22">
                                        <wm-form-field readonly="false" name="Autocomplete" displayname="Autocomplete"
                                            key="Autocomplete" type="string" show="true" widget="autocomplete">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow13">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn23">
                                        <wm-form-field readonly="false" name="time" displayname="Time" key="time"
                                            type="string" show="true" widget="time"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn25">
                                        <wm-form-field readonly="false" name="timestamp" displayname="Timestamp"
                                            key="timestamp" type="string" show="true" widget="timestamp">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow14">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn24">
                                        <wm-form-field readonly="false" name="date" displayname="Date" key="date"
                                            type="string" show="true" widget="date"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn26">
                                        <wm-form-field readonly="false" name="datetime" displayname="Datetime"
                                            key="datetime" type="string" show="true" widget="datetime"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow103">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn34">
                                        <wm-form-field readonly="false" name="password" displayname="Password"
                                            key="password" type="string" show="true" widget="password"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn33">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                            </wm-layoutgrid>
                        </wm-form>
                    </wm-gridcolumn>
                </wm-gridrow>
            </wm-layoutgrid>
            <wm-layoutgrid name="layoutgrid1">
                <wm-gridrow name="gridrow1">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn1">
                        <wm-label padding="unset" class="h4" type="p" name="label1" caption="3. Caption Position - Right">
                        </wm-label>
                    </wm-gridcolumn>
                </wm-gridrow>
                <wm-gridrow name="gridrow2">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn3">
                        <wm-form errormessage="" captionposition="right" 
                            enctype="application/x-www-form-urlencoded" method="post"
                            dataset="bind:Variables.stvformUsecases.dataSet" captionalign="left"
                            name="stvformUsecasesForm1" class="form-input">
                            <wm-layoutgrid columns="3" name="layoutgrid5">
                                <wm-gridrow name="gridrow9">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn11">
                                        <wm-form-field name="text Required" displayname="Text Required" show="true"
                                            placeholder="Enter text" type="string" key="text Required" widget="text"
                                            inputtype="text" readonly="false" required="true"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn12">
                                        <wm-form-field name="text" displayname="Text" show="true"
                                            placeholder="Enter text" type="string" key="text" widget="text"
                                            inputtype="text" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow19">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn13">
                                        <wm-form-field name="number Required" displayname="Number Required" show="true"
                                            placeholder="Enter Number" type="string" key="number Required"
                                            widget="number" inputtype="number" readonly="false" textalign="right" required="true">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn14">
                                        <wm-form-field name="number" displayname="Number" show="true"
                                            placeholder="Enter Number" type="string" key="number" widget="number"
                                            inputtype="number" readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow10">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn16">
                                        <wm-form-field name="textarea" displayname="Textarea" show="true"
                                            placeholder="Place your text" type="string" key="textarea" widget="textarea"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn15">
                                        <wm-form-field name="currency" displayname="Currency" show="true"
                                            placeholder="Enter value" type="string" key="currency" widget="currency"
                                            readonly="false" textalign="right"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow12">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn21">
                                        <wm-form-field name="Select" displayname="Select" show="true" placeholder=""
                                            type="string" key="Select" widget="select" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn22">                                    
                                        <wm-form-field name="Autocomplete" displayname="Autocomplete"
                                            matchmode="startignorecase" show="true" placeholder="Search" type="string"
                                            key="Autocomplete" widget="autocomplete" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow13">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn23">
                                        <wm-form-field name="time" displayname="Time" show="true"
                                            placeholder="Select time" type="string" key="time" widget="time"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn25">
                                        <wm-form-field name="timestamp" displayname="Timestamp" show="true"
                                            placeholder="Select date time" type="string" key="timestamp"
                                            widget="timestamp" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow14">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn24">
                                        <wm-form-field name="date" displayname="Date" show="true"
                                            placeholder="Select date" type="string" key="date" widget="date"
                                            datepattern="MMM d, y" outputformat="yyyy-MM-dd" readonly="false">
                                        </wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn26">
                                        <wm-form-field name="datetime" displayname="Datetime" show="true"
                                            placeholder="Select date time" type="string" key="datetime"
                                            widget="datetime" datepattern="MMM d, y h:mm:ss a" outputformat="timestamp"
                                            readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow16">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn34">
                                        <wm-form-field name="password" displayname="Password" show="true"
                                            placeholder="Enter text" type="string" key="password" widget="password"
                                            inputtype="password" readonly="false"></wm-form-field>
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn33">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                            </wm-layoutgrid>
                        </wm-form>
                    </wm-gridcolumn>
                </wm-gridrow>
            </wm-layoutgrid>
            `]
          }
        }
    }
  },
  'wm-page': {
    widgetType: 'wm-page',
    template: "<wm-page></wm-page>",
    isContainer: true,
    isResizable: false,
    isMovableInsideCanvas: false,
    isDroppable: false,
    isDeletable: false,
    canBeCopied: false
  },
  'wm-page-content': {
    widgetType: "wm-page-content",
    template: "<wm-page-content></wm-page-content>",
    isContainer: true,
    isResizable: false,
    isMovableInsideCanvas: false,
    isDroppable: true,
    isDeletable: false,
    canBeCopied: false
  },
  "wm-prefab": {
    widgetType: "wm-prefab",
    template: "<wm-prefab></wm-prefab>",
    isContainer: false,
    isResizable: true,
    isMovableInsideCanvas: true,
    isDroppable: false,
    isDeletable: true,
    canBeCopied: false
  },
  "wmx-component": {
    widgetType: "wmx-component",
    template: "<wmx-component></wmx-component>",
    isContainer: false,
    isResizable: true,
    isMovableInsideCanvas: true,
    isDroppable: false,
    isDeletable: true,
    canBeCopied: false
  },
  "wm-content": {
    widgetType: "wm-content",
    template: "<wm-content></wm-content>",
    isContainer: true,
    isResizable: false,
    isMovableInsideCanvas: false,
    isDroppable: true,
    isDeletable: false,
    canBeCopied: false
  },
  'wm-list': {
    widgetType: "wm-list",
    template: "<wm-list listclass='list-group' itemclass='list-group-item' statehandler='URL'><wm-listtemplate layout='panel'></wm-listtemplate></wm-list>",
    isContainer: false,
    isResizable: true,
    isMovableInsideCanvas: true,
    isDroppable: false,
    isDeletable: true,
    canBeCopied: true,
    isTemplateBundled: true,
    tokenFileName: "list",
    config: {
      'requireVariable': true,
      'title': 'List',
      'bindTypes': ['wm-livefilter', 'wm-list', 'wm-table', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'livelist-config',
          "label": "Template",
          "screen": "templateConfig",
          "liveWidgetId": "wm-list",
          "description": "MESSAGE_WIDGET_SELECT_TEMPLATE",
          "templates": [
            {
              "id": "text-list",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-label name="Text" caption="{}" data-is-target class="h4" padding="12px"></wm-label>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-avatar-list",
              "title": "Text with Avatar",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Avatar List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container direction="row" alignment="middle-left" gap="12" width="fill" name="container4" class="app-default-container" variant="default" padding="12px">' +      
                '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                '<wm-container direction="column" flexgrow="1" gap="12" width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5"></wm-label>' +
                '</wm-container>' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-description-list",
              "title": "Text with Description",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
               "template":
                      ' <wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Description List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                      '<wm-listtemplate layout="inline">' +
                      ' <wm-container direction="row" alignment="top-left" gap="12" name="container4" class="app-default-container" variant="default" padding="12px">' +
                      '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                      '<wm-container direction="column" spacing="4" padding="0px>' +
                      '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                      '<wm-label name="SubTitle" caption="{}" margin="unset 4px" data-is-target></wm-label>' +
                      '<wm-label name="Description" caption="{}" data-is-target class="h5"></wm-label>' +
                      "</wm-container" +
                      "</wm-container>" +
                      "</wm-listtemplate>" +
                      "</wm-list>",
            },
            {
              "id": "action-list",
              "title": "Action List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Action List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="p media-heading" caption="{}" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top">' +
                '<wm-button class="btn-transparent" iconclass="wi wi-share fa-2x"></wm-button>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-list",
              "title": "Contact List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Contact List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" datafield="All Fields" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="p media-heading" name="Name" data-is-target caption="{}" fontunit="em" padding="unset unset unset 1.25em"></wm-label>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "email-list",
              "title": "Email List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Email List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container name="pictureContainer" class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="media-heading pull-left" caption="{}" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target caption="{}" class="pull-right" margin="0px unset unset unset"></wm-label>' +
                '<wm-label caption="{}" data-is-target class="h5" margin="0px unset unset unset" name="JobTitle"></wm-label>' +
                '<wm-label name="Content" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right"></wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "media-list",
              "title": "Media List",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Media List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left media-top">' +
                '<wm-picture name="Picture" data-is-target class="media-object" width="32pt" height="32pt" picturesource="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset 1.5em unset 1.25em">' +
                '<wm-label class="pull-left" caption="{}" data-is-target name="Name" margin="0em unset 0.5em unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target class="pull-right text-muted" caption="{}"></wm-label>' +
                '<wm-label caption="{}" data-is-target name="Description" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right" horizontalalign="right" padding="unset 1em unset unset">' +
                '<wm-menu autoclose="outsideClick" caption="" type="anchor" iconclass="wi wi-more-vert" menuposition="down,left"></wm-menu>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "list-form-device",
              "title": "List with Form",
              "platform": ["MOBILE"],
              "template":
                '<wm-list listclass="list-group" itemclass="list-group-item media" template="true" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left">' +
                '<wm-picture data-is-target class="media-object picture" shape="circle" width="40pt" name="Picture" picturesource="{}" hint="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label data-is-target caption="{}" name="Name" class="p media-heading" ></wm-label>' +
                '<wm-label data-is-target caption="{}" class="p text-muted" name="Title"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top" width="20%" name="container9" horizontalalign="right">' +
                '<wm-buttongroup name="buttongroup1">' +
                '<wm-button class="btn-transparent edit-list-item" caption="" name="button1" iconclass="wi wi-pencil fa-2x" margin="unset 0.2em unset unset"></wm-button>' +
                '<wm-button class="btn-transparent delete-list-item" caption="" name="button2" iconclass="wi wi-trash fa-2x"></wm-button>' +
                '</wm-buttongroup>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>'
            }
          ]
        },
        {
          "id": 'livelist-fields',
          "label": "Bind Fields",
          "screen": "liveListFieldConfig",
          "description": "MESSAGE_WIDGET_MAP_FIELDS",
          "liveWidgetId": "wm-list"
        }
      ]
    }
  },
  'wm-listtemplate': {
    "widgetType": "wm-listtemplate",
    "template": "<wm-listtemplate></wm-listtemplate>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-form': {
    "widgetType": "wm-form",
    "template": "<wm-form></wm-form>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"form-wrapper",
    "config": {
      'requireVariable': true,
      'title': 'Form',
      'requireTemplate': false,
      'screens': [
        {
          "id": 'form-layout',
          "label": "Form Layout",
          "labelKey": "LABEL_FORM_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_CAPTION_POSITION_ALIGN",
          "liveWidgetId": "wm-form",
          "templates": [
            {
              "id": "one-column",
              "title": "1 column",
              "labelKey": "LABEL_1_COLUMN",
              "platform": ["WEB", "MOBILE", "NATIVE_MOBILE"],
              "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded">' +
                '<wm-layoutgrid></wm-layoutgrid>' +
                '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
                '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
                '</wm-form>'
            },
            {
              "id": "two-column",
              "title": "2 column",
              "labelKey": "LABEL_2_COLUMN",
              "platform": ["WEB"],
              "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded">' +
                '<wm-layoutgrid></wm-layoutgrid>' +
                '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
                '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
                '</wm-form>'
            },
            {
              "id": "three-column",
              "title": "3 column",
              "labelKey": "LABEL_3_COLUMN",
              "platform": ["WEB"],
              "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded">' +
                '<wm-layoutgrid></wm-layoutgrid>' +
                '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
                '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
                '</wm-form>'
            },
            {
              "id": "dialog-form",
              "title": "Dialog Form",
              "labelKey": "LABEL_MOBILE_DIALOG_FORM",
              "platform": ["MOBILE"],
              "requireColumns": false,
              "template": "<wm-form  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='dialog'><wm-layoutgrid></wm-layoutgrid></wm-form>"
            }
          ]
        },
        {
          "id": 'form-fields',
          "label": "Form Fields",
          "labelKey": "LABEL_FORM_FIELDS",
          "screen": "widgetFieldTree",
          "description": "MESSAGE_FORM_FIELD_CONFIG",
          "liveWidgetId": "wm-form"
        }
      ]
    },
    "styleWorkspaceTemplates":{
       platforms: {
        native_mobile: {
          customTemplate:[`<wm-layoutgrid name="layoutgrid1">
                <wm-gridrow name="gridrow2">
                    <wm-gridcolumn columnwidth="12" name="gridcolumn3">
                        <wm-form errormessage="" captionposition="left" title="Form"
                            enctype="application/x-www-form-urlencoded" method="post"
                            dataset="bind:Variables.stvformUsecases.dataSet" captionalign="left"
                            name="stvformUsecasesForm1" subheading="sub-heading">
                            <wm-layoutgrid columns="3" name="layoutgrid5">
                                <wm-gridrow name="gridrow9">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn11">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn12">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow47">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn13">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn14">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow10">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn16">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn15">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow111">
                                        <wm-gridcolumn columnwidth="6" name="gridcolumn21">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn22">
                                    </wm-gridcolumn>
                                        
                                </wm-gridrow>
                                <wm-gridrow name="gridrow13">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn23">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn25">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow14">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn24">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn26">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                                <wm-gridrow name="gridrow16">
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn34">
                                    </wm-gridcolumn>
                                    <wm-gridcolumn columnwidth="6" name="gridcolumn33">
                                    </wm-gridcolumn>
                                </wm-gridrow>
                            </wm-layoutgrid>
                            <wm-form-action key="reset" name="reset" display-name="Reset" show="true"
                                class="form-reset btn-default" iconclass="wi wi-refresh" title="Reset" disabled="false"
                                widget-type="button" type="reset" update-mode="true"></wm-form-action>
                            <wm-form-action key="save" name="save" display-name="Save" show="true"
                                class="form-save btn-success" iconclass="wi wi-save" title="Save" disabled="false"
                                widget-type="button" type="submit" update-mode="true"></wm-form-action>
                        </wm-form>
                    </wm-gridcolumn>
                </wm-gridrow>
            </wm-layoutgrid>
            `]
          }
        }
    }
  },
  'wm-liveform': {
    "widgetType": "wm-liveform",
    "template": "<wm-liveform title='Details'></wm-liveform>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "config": {
      'requireVariable': true,
      'title': 'Live Form',
      'bindTypes': ['wm-table', 'wm-liveform', 'wm-livefilter', 'wm-list'],
      'screens': [
        {
          "id": 'liveform-layout',
          "label": "Form Layout",
          "labelKey": "LABEL_FORM_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_CAPTION_POSITION_ALIGN",
          "liveWidgetId": "wm-liveform",
          "templates": [
            {
              "id": "one-column",
              "title": "1 column",
              "labelKey": "LABEL_1_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "two-column",
              "title": "2 column",
              "labelKey": "LABEL_2_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "three-column",
              "title": "3 column",
              "labelKey": "LABEL_3_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "mobile-inline",
              "title": "Inline",
              "labelKey": "LABEL_MOBILE_INLINE",
              "platform": ['MOBILE', 'NATIVE_MOBILE'],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='inline'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "mobile-page",
              "title": "Page",
              "labelKey": "LABEL_MOBILE_PAGE",
              "platform": ["MOBILE"],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='page'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "dialog-form",
              "title": "Dialog Form",
              "labelKey": "LABEL_MOBILE_DIALOG_FORM",
              "platform": ["MOBILE"],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='dialog'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            }
          ]
        },
        {
          "id": 'liveform-fields',
          "label": "Form Fields",
          "labelKey": "LABEL_FORM_FIELDS",
          "screen": "widgetFieldConfig",
          "liveWidgetId": "wm-liveform"
        }
      ]
    }
  },
  'wm-livefilter': {
    "widgetType": "wm-livefilter",
    "template": "<wm-livefilter></wm-livefilter>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false,
    "config": {
      'requireVariable': true,
      'title': 'Live Filter',
      'bindTypes': ['wm-liveform'],
      'screens': [
        {
          "id": 'livefilter-layout',
          "label": "Filter Layout",
          "labelKey": "LABEL_FILTER_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_CAPTION_POSITION_ALIGN",
          "liveWidgetId": "wm-livefilter",
          "templates": [
            {
              "id": "one-column",
              "title": "1 Column",
              "labelKey": "LABEL_1_COLUMN",
              "platform": ["WEB", "MOBILE"]
            },
            {
              "id": "two-column",
              "title": "2 Column",
              "labelKey": "LABEL_2_COLUMN",
              "platform": ["WEB", "MOBILE"]
            },
            {
              "id": "three-column",
              "title": "3 Column",
              "labelKey": "LABEL_3_COLUMN",
              "platform": ["WEB", "MOBILE"]
            }
          ]
        },
        {
          "id": 'livefilter-fields',
          "label": "Filter Fields",
          "labelKey": "LABEL_FILTER_Fields",
          "screen": "widgetFieldConfig",
          "liveWidgetId": "wm-livefilter"
        }
      ]
    }
  },
  'wm-table': {
    "widgetType": "wm-table",
    "template":
      '<wm-table>' +
      '<wm-table-column caption="Column1" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column2" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column3" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column4" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '<wm-table-column caption="Column5" pcdisplay="true" mobiledisplay="true"></wm-table-column>' +
      '</wm-table>',
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "config": {
      'requireVariable': true,
      'title': 'Data Table',
      'bindTypes': ['wm-table', 'wm-liveform', 'wm-livefilter', 'wm-list', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'grid-template',
          "label": "Layout",
          "labelKey": "LABEL_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_TEMPLATE_SELECT_WIDGET",
          "liveWidgetId": "wm-table",
          "templates": [
            {
              "id": "readonly-grid",
              "title": "Simple View only",
              "labelKey": "LABEL_SIMPLE_VIEW_ONLY",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "editable-grid",
              "title": "Inline Editable",
              "labelKey": "LABEL_INLINE_EDITABLE",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="inline" statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "crud-grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "crud-grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "crud-grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-form>'
            },
            {
              "id": "grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage=""  title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "quick-inline-editable",
              "title": "Quick Edit",
              "labelKey": "LABEL_QUICK_EDIT",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="quickedit" statehandler="URL">' +
                '</wm-table>'
            }
          ]
        },
        {
          "id": 'grid-columns',
          "label": "Table Columns",
          "labelKey": "LABEL_TABLE_COLUMNS",
          "screen": "widgetFieldConfig",
          "description": "MESSAGE_TEMPLATE_MAP_FIELDS",
          "liveWidgetId": "wm-table"
        }
      ]
    }
  },
  'wm-select': {
    "widgetType": "wm-select",
    "template": "<wm-select></wm-select>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls",
    "styleWorkspaceTemplates": {
      customTemplate: [`
    <div class="native-template-selectcontainer">
      <div class="native-template-form-group">
        <div class="native-template-select-box">
          <span>Select</span>
          <div class="native-template-arrow-container">
            <span class="native-template-arrow"></span>
          </div>
        </div>
      </div>

      <div class="native-template-dropdown-modal">
        <div class="native-template-option option-selected">
          Option 1
          <span class="native-template-option-tick">✓</span>
        </div>
        <hr class="native-template-horizontalline"/>
        <div class="native-template-option">
          Option 2
        </div>
        <hr class="native-template-horizontalline"/>
        <div class="native-template-option">
          Option 3
        </div>
      </div>
    </div>`]
        }
      },
  "wm-text": {    
    "widgetType": "wm-text",
    "template": "<wm-text></wm-text>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls"
  },
  "wm-composite": {
    "widgetType": "wm-composite",
    "template": "<wm-composite></wm-composite>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true
  },
  "wm-composite-text": {
    "widgetType": "wm-composite-text",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-text></wm-text>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-text></wm-text>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-text></wm-text>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-number": {
    "widgetType": "wm-composite-number",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-number textalign='right'></wm-number>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-number textalign='right'></wm-number>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-number textalign='right'></wm-number>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-number": {
    "widgetType": "wm-number",
    "template": "<wm-number textalign='right'></wm-number>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls"
  },
  "wm-composite-colorpicker": {
    "widgetType": "wm-composite-colorpicker",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-colorpicker></wm-colorpicker>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-colorpicker></wm-colorpicker>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-colorpicker></wm-colorpicker>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-select": {
    "widgetType": "wm-composite-select",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-select></wm-select>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-select></wm-select>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-select></wm-select>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-selectlocale": {
    "widgetType": "wm-composite-selectlocale",
    "tokenFileName": "form-controls",
    "template": '<wm-select class="select-locale" dataset="bind:Variables.supportedLocale.dataSet" on-change="App.changeLocale(newVal);App.reload();" placeholder="Select Language"></wm-select>',
    "platforms":{
         "native_mobile": {
        "template":
         '<wm-select class="select-locale" dataset="bind:Variables.supportedLocale.dataSet" on-change="App.changeLocale(newVal);App.reload();" placeholder="Select Language" accessibilitylabel="Select a language"></wm-select>'
      },
    }
  },
  "wm-textarea": {
    "widgetType": "wm-textarea",
    "template": "<wm-textarea></wm-textarea>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls"
  },
  "wm-checkbox": {
    "widgetType": "wm-checkbox",
    "template": "<wm-checkbox></wm-checkbox>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "checkbox", 
    "styleWorkspaceTemplates" : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow1" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn2" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="checked = true" name="label2"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn3" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="checked = false, disabled = true" name="label3"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="3" name="gridcolumn4"></wm-gridcolumn>
      </wm-gridrow>
  
      <wm-gridrow name="gridrow2" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn7">
              <wm-composite name="composite1" captionposition="left">
                  <wm-checkbox caption="Label" class="col-md-push-3 col-md-9" name="checkbox1"
                      datavalue="true" uncheckedvalue="false" checkedvalue="true" disabled="false" readonly="false"></wm-checkbox>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn8">
              <wm-composite captionposition="left" name="composite2">
                  <wm-checkbox caption="Label" class="col-md-push-3 col-md-9" datavalue="false"
                      uncheckedvalue="false" checkedvalue="true" disabled="true" readonly="false" name="checkbox2"></wm-checkbox>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="3" name="gridcolumn9">
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`,
  customTemplate:[`<wm-composite name="composite1" captionposition="left">
                  <wm-checkbox caption="Label" class="col-md-push-3 col-md-9" name="checkbox1"
                      datavalue="true" uncheckedvalue="false" checkedvalue="true" disabled="false" readonly="false"></wm-checkbox>
              </wm-composite>`]
    }
  },
  "wm-checkboxset": {
    "widgetType": "wm-checkboxset",
    "template": "<wm-checkboxset></wm-checkboxset>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "checkboxset", 
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow1" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn1">
              <wm-label padding="unset" class="p" type="p" caption="Caption Position" name="label1"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn2"></wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn3"></wm-gridcolumn>
      </wm-gridrow>
  
      <wm-gridrow name="gridrow2" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn4">
              <wm-label padding="unset" class="p" type="p" caption="default" name="label2"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn5">
              <wm-composite name="composite1">
                  <wm-label class="col-md-2 control-label" notag="true" name="label3"></wm-label>
                  <wm-container class="col-md-10" name="container1">
                      <wm-checkboxset height="auto" name="checkboxset1" datavalue="Option 1"></wm-checkboxset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  
      <wm-gridrow name="gridrow3" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn6">
              <wm-label padding="unset" class="p" type="p" caption="left" name="label4"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn7">
              <wm-composite name="composite2" captionposition="left">
                  <wm-label class="col-md-2 control-label" notag="true" name="label5"></wm-label>
                  <wm-container class="col-md-10" name="container2">
                      <wm-checkboxset height="auto" name="checkboxset2" datavalue="Option 1"></wm-checkboxset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  
      <wm-gridrow name="gridrow4" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn8">
              <wm-label padding="unset" class="p" type="p" caption="right" name="label6"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn9">
              <wm-composite name="composite3" captionposition="right">
                  <wm-label class="col-md-2 control-label" notag="true" name="label7"></wm-label>
                  <wm-container class="col-md-10" name="container3">
                      <wm-checkboxset height="auto" name="checkboxset3" datavalue="Option 1" itemsperrow="xs-1 sm-1 md-2 lg-2"></wm-checkboxset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  
      <wm-gridrow name="gridrow5" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn10">
              <wm-label padding="unset" class="p" type="p" caption="top" name="label8"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn11">
              <wm-composite name="composite4" captionposition="top">
                  <wm-label class="col-md-2 control-label" notag="true" name="label9"></wm-label>
                  <wm-container class="col-md-10" name="container4">
                      <wm-checkboxset height="auto" name="checkboxset4" datavalue="Option 1"></wm-checkboxset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>
  `,  
      customTemplate: [`<wm-checkboxset datavalue="Option 1"></wm-checkboxset>`]
    }
  },
  "wm-composite-checkbox": {
    "widgetType": "wm-composite-checkbox",
    "template":
      "<wm-composite>" +
      "<wm-checkbox caption='Label' class='col-md-push-3 col-md-9'></wm-checkbox>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-checkbox caption='Label'></wm-checkbox>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-checkbox caption='Label'></wm-checkbox>" +
          "</wm-composite>"
      }
    }
  },
  "wm-buttongroup": {
    "widgetType": "wm-buttongroup",
    "template":
      "<wm-buttongroup>" +
      "<wm-button class='btn-default' type='button' caption='left'></wm-button>" +
      "<wm-button class='btn-default' type='button' caption='center'></wm-button>" +
      "<wm-button class='btn-default' type='button' caption='right'></wm-button>" +
      "</wm-buttongroup>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "button-group",
    styleWorkspaceTemplates:{
      customTemplate:  ["<wm-buttongroup>" +
      "<wm-button class='btn-filled btn-default' type='button' caption='left'></wm-button>" +
      "<wm-button class='btn-filled btn-primary' type='button' caption='center'></wm-button>" +
      "<wm-button class='btn-filled btn-default' type='button' caption='right'></wm-button>" +
      "</wm-buttongroup>"],
      "platforms": {
        "native_mobile": {
          customTemplate: ["<wm-buttongroup>" +
            "<wm-button class='btn-filled-default' type='button' caption='left'></wm-button>" +
            "<wm-button class='btn-filled-primary' type='button' caption='center'></wm-button>" +
            "<wm-button class='btn-filled-default' type='button' caption='right'></wm-button>" +
            "</wm-buttongroup>"]
        }
      }
    }
  },
  "wm-icon": {
    "widgetType": "wm-icon",
    "template": "<wm-icon></wm-icon>",
    "isContainer": true,
    "isResizable": false,
    "tokenFileName": "icon",
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  "wm-composite-currency": {
    "widgetType": "wm-composite-currency",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-currency textalign='right'></wm-currency>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-currency textalign='right'></wm-currency>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-currency textalign='right'></wm-currency>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-currency": {
    "widgetType": "wm-currency",
    "template": "<wm-currency textalign='right'></wm-currency>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls", 
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow5" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn9">
              <wm-label padding="unset" class="p" type="p" caption="Caption Position" name="label7" ></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn10">
              <wm-label padding="unset" class="p" type="p" caption="Enabled" name="label13_1"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn11">
              <wm-label padding="unset" class="p" type="p" caption="Disabled" name="label14_2" show="false"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn27">
              <wm-label padding="unset" class="p" type="p" caption="Read Only" name="label21" show="false"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow4" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn12">
              <wm-label padding="unset" class="p" type="p" caption="default" name="label8"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn7">
                  <wm-label class="col-md-3 control-label" notag="true" name="label13"></wm-label>
                  <wm-container class="col-md-9" name="container6">
                      <wm-currency textalign="right"></wm-currency>
                  </wm-container>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow2" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn13">
              <wm-label padding="unset" class="p" type="p" caption="left" name="label9"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn3">
                  <wm-label class="col-md-3 control-label" notag="true" name="label14_1"></wm-label>
                  <wm-container class="col-md-9" name="container7">
                      <wm-currency textalign="right" name="currency2" placeholder="Enter Value"></wm-currency>
                  </wm-container>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow6" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn14">
              <wm-label padding="unset" class="p" type="p" caption="right" name="label11"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn17">
                  <wm-label class="col-md-3 control-label" notag="true" name="label15"></wm-label>
                  <wm-container class="col-md-9" name="container8">
                      <wm-currency textalign="right" name="currency3" placeholder="Enter Value"></wm-currency>
                  </wm-container>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow3" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn18">
              <wm-label padding="unset" class="p" type="p" caption="top" name="label12"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn5">
              <wm-composite name="composite9" captionposition="top">
                  <wm-label class="col-md-3 control-label" notag="true" name="label16"></wm-label>
                  <wm-container class="col-md-9" name="container9">
                      <wm-currency textalign="right" name="currency4" placeholder="Enter Value"></wm-currency>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow7" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn19">
              <wm-label padding="unset" class="p" type="p" caption="Floating" name="label14"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn20">
              <wm-composite name="composite10" captionposition="floating">
                  <wm-label class="col-md-3 control-label" notag="true" name="label17"></wm-label>
                  <wm-container class="col-md-9" name="container10">
                      <wm-currency textalign="right" name="currency5" placeholder="Enter Value"></wm-currency>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`
    }
  },
  "wm-slider": {
    "widgetType": "wm-slider",
    "template": "<wm-slider></wm-slider>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "slider",
    "platforms": {
      "native_mobile": {
        "template" : `<wm-slider name="slider1" showmarkers="true" showtooltip="true" range="false" minvalue="0" maxvalue="100" step="10" datavalue="50"></wm-slider>`
        }
    },
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow5" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="6" name="gridcolumn9">
              <wm-label padding="unset" class="p" type="p" caption="Range Label Position" name="label7"></wm-label>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow4" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn12">
              <wm-label padding="unset" class="p" type="p" caption="top" name="label8"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn7">
              <wm-composite name="composite5">
                  <wm-container class="col-md-9" name="container5">
                        <wm-slider minvalue="0" maxvalue="100" datavalue="50" rangelabelposition="top"></wm-slider>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow2" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn13">
              <wm-label padding="unset" class="p" type="p" caption="bottom" name="label9"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn3">
              <wm-composite name="composite7">
                  <wm-container class="col-md-9" name="container7">
                      <wm-slider minvalue="0" maxvalue="100" datavalue="50" rangelabelposition="bottom"></wm-slider>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow6" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn14">
              <wm-label padding="unset" class="p" type="p" caption="side" name="label11"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn17">
              <wm-composite name="composite8">
                  <wm-container class="col-md-9" name="container8">
                      <wm-slider minvalue="0" maxvalue="100" datavalue="50" rangelabelposition="side"></wm-slider>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`, 
  customTemplate : [`<wm-slider minvalue="0" maxvalue="100" datavalue="50" class="pb-3"></wm-slider>`]
    }
  },
  "wm-composite-slider": {
    "widgetType": "wm-composite-slider",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-slider></wm-slider>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-slider></wm-slider>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-slider></wm-slider>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-textarea": {
    "widgetType": "wm-composite-textarea",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-textarea></wm-textarea>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-textarea></wm-textarea>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-textarea></wm-textarea>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-tree": {
    "widgetType": "wm-tree",
    "template": "<wm-tree></wm-tree>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "isLayoutBundled": true

  },
  "wm-composite-toggle": {
    "widgetType": "wm-composite-toggle",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-checkbox caption='Toggle' type='toggle'></wm-checkbox>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-8 control-label'></wm-label>" +
          "<wm-container class='col-xs-4'>" +
          "<wm-checkbox class='pull-right' caption='Toggle' type='toggle'></wm-checkbox>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-8 control-label'></wm-label>" +
          "<wm-container class='col-xs-4'>" +
          "<wm-checkbox class='pull-right' caption='Toggle' type='toggle' accessibilityrole='togglebutton'></wm-checkbox>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-iconbutton-toggle": {
    "widgetType": "wm-iconbutton-toggle",
    "template": "<wm-checkbox type='button' unselectedicon='wm-sl-l sl-volume-full' selectedicon='wm-sl-l sl-volume-off'></wm-checkbox>",
    styleWorkspaceTemplates : { 
      customTemplate : [`<wm-checkbox type="button" name="iconbutton-toggle" disabled="false" required="true"
                      uncheckedvalue="false" checkedvalue="true" datavalue="false"></wm-checkbox>`, `<wm-checkbox type="button"  name="iconbutton-toggle" disabled="false" class="px-10" required="true"
                      uncheckedvalue="false" checkedvalue="true" datavalue="true"></wm-checkbox>`]
    }
  },
  "wm-menu": {
    "widgetType": "wm-menu",
    "template": "<wm-menu caption='Menu' autoclose='outsideClick'></wm-menu>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    tokenFileName:"dropdown-menu", 
  },
  "wm-composite-checkboxset": {
    "widgetType": "wm-composite-checkboxset",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-checkboxset height='auto'></wm-checkboxset>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-checkboxset height='auto'></wm-checkboxset>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-checkboxset height='auto'></wm-checkboxset>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    },
    tokenFileName:"checkboxset"
  },
  "wm-composite-date": {
    "widgetType": "wm-composite-date",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-date></wm-date>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-date></wm-date>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-date></wm-date>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-datetime": {
    "widgetType": "wm-composite-datetime",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-datetime></wm-datetime>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-datetime></wm-datetime>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-datetime></wm-datetime>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-composite-time": {
    "widgetType": "wm-composite-time",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-time></wm-time>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-time></wm-time>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-time></wm-time>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-radioset": {
    "widgetType": "wm-radioset",
    "template": "<wm-radioset></wm-radioset>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "radioset",
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow5" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn9">
              <wm-label padding="unset" class="p" type="p" caption="Caption Position" name="label7"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn10"></wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn11"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow4" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn12">
              <wm-label padding="unset" class="p" type="p" caption="default" name="label8"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn7">
              <wm-composite name="composite5">
                  <wm-label class="col-md-3 control-label" notag="true" name="label11_1"></wm-label>
                  <wm-container class="col-md-9" name="container5">
                      <wm-radioset height="auto" name="radioset1" datavalue="Option 1"></wm-radioset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn8"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow2" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn13">
              <wm-label padding="unset" class="p" type="p" caption="left" name="label9"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn3">
              <wm-composite name="composite7" captionposition="left">
                  <wm-label class="col-md-3 control-label" notag="true" name="label13"></wm-label>
                  <wm-container class="col-md-9" name="container7">
                      <wm-radioset height="auto" name="radioset3" itemclass="success"></wm-radioset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn4"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow6" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn14">
              <wm-label padding="unset" class="p" type="p" caption="right" name="label11"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="4" name="gridcolumn17">
              <wm-composite name="composite8" captionposition="right">
                  <wm-label class="col-md-3 control-label" notag="true" name="label14"></wm-label>
                  <wm-container class="col-md-9" name="container8">
                      <wm-radioset height="auto" name="radioset4" itemclass="error"></wm-radioset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="6" name="gridcolumn15"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow3" class="d-flex align-items-center">
          <wm-gridcolumn columnwidth="2" name="gridcolumn18">
              <wm-label padding="unset" class="p" type="p" caption="top" name="label12"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="8" name="gridcolumn5">
              <wm-composite name="composite9" captionposition="top">
                  <wm-label class="col-md-3 control-label" notag="true" name="label15"></wm-label>
                  <wm-container class="col-md-9" name="container9">
                      <wm-radioset height="auto" name="radioset5"></wm-radioset>
                  </wm-container>
              </wm-composite>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="2" name="gridcolumn6"></wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`, 
  customTemplate : [`<wm-radioset datavalue="Option 1"></wm-radioset>`]
    }
  },
  "wm-composite-radioset": {
    "widgetType": "wm-composite-radioset",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-radioset height='auto'></wm-radioset>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-radioset height='auto'></wm-radioset>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-radioset height='auto'></wm-radioset>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }

  },
  "wm-progress-bar": {
    "widgetType": "wm-progress-bar",
    "template": "<wm-progress-bar datavalue='30'></wm-progress-bar>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "progress-bar"
  },
  "wm-search": {
    "widgetType": "wm-search",
    "template": "<wm-search></wm-search>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "search",
    "platforms": {
      "native_mobile": {
        "template": "<wm-search debouncetime='250'></wm-search>",
      }
    },
  //   styleWorkspaceTemplates : {
  //     usageTemplate : `<wm-layoutgrid name="layoutgrid1">
  //     <wm-gridrow name="gridrow2">
  //         <wm-gridcolumn columnwidth="12" name="gridcolumn3">
  //             <wm-label padding="unset" class="p" type="p" name="label2" caption="Search widget with clear button"></wm-label>
  //             <wm-search name="search5_1" required="true" showclear="true" disabled="false" dataset="bind:Variables.searchdorpdownlist.dataSet" displaylabel="firstname" displayimagesrc="picurl" datafield="All Fields"></wm-search>
  //         </wm-gridcolumn>
  //         <wm-gridcolumn columnwidth="12" name="gridcolumn4">
  //             <wm-label padding="unset" class="p" type="p" caption="search with out clear button" name="label3"></wm-label>
  //             <wm-search required="true" showclear="false" disabled="false" dataset="bind:Variables.searchdorpdownlist.dataSet" displaylabel="firstname" displayimagesrc="picurl" datafield="All Fields" groupby="department.deptId" name="search5_2" imagewidth="32px"></wm-search>
  //         </wm-gridcolumn>
  //     </wm-gridrow>
  //     <wm-gridrow name="gridrow3">
  //         <wm-gridcolumn columnwidth="12" name="gridcolumn5">
  //             <wm-label padding="unset" class="p" type="p" caption="Search (search the results without typing and  with search button))" name="label4"></wm-label>
  //             <wm-search required="true" showclear="true" disabled="false" dataset="bind:Variables.searchdorpdownlist.dataSet" displaylabel="firstname" displayimagesrc="picurl" datafield="All Fields" groupby="department.deptId" name="search6" searchon="onsearchiconclick"></wm-search>
  //         </wm-gridcolumn>
  //         <wm-gridcolumn columnwidth="12" name="gridcolumn6">
  //             <wm-label padding="unset" class="p" type="p" caption="Autocomplete Search" name="label5"></wm-label>
  //             <wm-search required="true" showclear="true" disabled="false" dataset="bind:Variables.searchdorpdownlist.dataSet" displaylabel="firstname" displayimagesrc="picurl" datafield="All Fields" groupby="department.deptId" name="search7" type="autocomplete"></wm-search>
  //         </wm-gridcolumn>
  //     </wm-gridrow>
  // </wm-layoutgrid>`
  //   }, 
  },
  "wm-chips": {
    "widgetType": "wm-chips",
    "template": "<wm-chips></wm-chips>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "chips",
    styleWorkspaceTemplates: {
      customTemplate: [`<wm-chips name="chips1" class="app-chips filled" datavalue="Option 1">`]
    }
  },
  "wm-rating": {
    "widgetType": "wm-rating",
    "template": "<wm-rating></wm-rating>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "rating", 
    styleWorkspaceTemplates : {
      usageTemplate : 
      `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
      <wm-gridrow name="gridrow2" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn3" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Not Rated" name="label2"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn2">
              <wm-rating name="rating1" maxvalue="5" readonly="false" showcaptions="false" activeiconclass="fa fa-heart" inactiveiconclass="fa fa-heart-o"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow3" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn4" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Rated" name="label3"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn5">
              <wm-rating datavalue="3" maxvalue="5" readonly="false" name="rating2" showcaptions="false"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow4" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn6" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Not Rated With Caption" name="label4"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn7">
              <wm-rating maxvalue="5" readonly="false" name="rating3" showcaptions="true"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow5" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn8" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Rated With Caption" name="label5"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn9">
              <wm-rating datavalue="3" maxvalue="5" readonly="false" showcaptions="true" name="rating4" caption="caption"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow6" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn10" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Not Rated ReadOnly" name="label6"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn11">
              <wm-rating maxvalue="5" readonly="true" showcaptions="false" name="rating5"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow7" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn12" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Rated ReadOnly" name="label7"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn13">
              <wm-rating datavalue="3" maxvalue="5" readonly="true" showcaptions="false" name="rating6"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow8" class="align-items-center">
          <wm-gridcolumn columnwidth="3" name="gridcolumn14" horizontalalign="left">
              <wm-label padding="unset" class="p" type="p" caption="Rated With Caption ReadOnly" name="label8"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="9" name="gridcolumn15">
              <wm-rating datavalue="3" maxvalue="5" readonly="true" showcaptions="true" name="rating7" caption="caption"></wm-rating>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`,
    customTemplate: [`<wm-rating datavalue="3" maxvalue="5" readonly="true" showcaptions="true"></wm-rating>`]
    }
   
  },
  "wm-switch": {
    "widgetType": "wm-switch",
    "template": "<wm-switch></wm-switch>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "switch", 
    styleWorkspaceTemplates : {
      customTemplate : [`<wm-switch datavalue="yes"></wm-switch>`],
    }
  },
  "wm-composite-switch": {
    "widgetType": "wm-composite-switch",
    "template":
      "<wm-composite>" +
      "<wm-label class='col-md-3 control-label' notag='true'></wm-label>" +
      "<wm-container class='col-md-9'>" +
      "<wm-switch datavalue='yes'></wm-switch>" +
      "</wm-container>" +
      "</wm-composite>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-switch class='pull-right' datavalue='yes'></wm-switch>" +
          "</wm-container>" +
          "</wm-composite>"
      },
      "native_mobile": {
        "template":
          "<wm-composite>" +
          "<wm-label class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'>" +
          "<wm-switch class='pull-right' datavalue='yes'></wm-switch>" +
          "</wm-container>" +
          "</wm-composite>"
      }
    }
  },
  "wm-html": {
    "widgetType": "wm-html",
    "template": "<wm-html></wm-html>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  "wm-picture": {
    "widgetType": "wm-picture",
    "template": "<wm-picture resizemode=\"cover\"></wm-picture>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "picture"
  },
  "wm-date": {
    "widgetType": "wm-date",
    "template": "<wm-date placeholder='Select Date'></wm-date>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls", 
    styleWorkspaceTemplates : {
      usageTemplate: `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
    <wm-gridrow name="gridrow5" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn9">
            <wm-label padding="unset" class="p" type="p" caption="Caption Position" name="label7"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn10"></wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn11"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow4" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn12">
            <wm-label padding="unset" class="p" type="p" caption="default" name="label8"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn7">
            <wm-composite name="composite6">
                <wm-label class="col-md-3 control-label" notag="true" name="label13"></wm-label>
                <wm-container class="col-md-9" name="container6">
                    <wm-date name="date1" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn8"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow2" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn13">
            <wm-label padding="unset" class="p" type="p" caption="left" name="label9"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn3">
            <wm-composite name="composite7">
                <wm-label class="col-md-3 control-label" notag="true" name="label14_1"></wm-label>
                <wm-container class="col-md-9" name="container7">
                    <wm-date name="date2" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn4"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow6" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn14">
            <wm-label padding="unset" class="p" type="p" caption="right" name="label11"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn17">
            <wm-composite name="composite8" captionposition="right">
                <wm-label class="col-md-3 control-label" notag="true" name="label15"></wm-label>
                <wm-container class="col-md-9" name="container8">
                    <wm-date name="date3" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn15"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow3" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn18">
            <wm-label padding="unset" class="p" type="p" caption="top" name="label12"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn5">
            <wm-composite name="composite9" captionposition="top">
                <wm-label class="col-md-3 control-label" notag="true" name="label16"></wm-label>
                <wm-container class="col-md-9" name="container9">
                    <wm-date name="date4" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn6"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow7" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn19">
            <wm-label padding="unset" class="p" type="p" caption="Floating" name="label14"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn20">
            <wm-composite name="composite11" captionposition="floating">
                <wm-label class="col-md-3 control-label" notag="true" name="label18"></wm-label>
                <wm-container class="col-md-9" name="container11">
                    <wm-date name="date6" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn21"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow8" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn21_1">
            <wm-label padding="unset" class="p" type="p" name="label14_2" caption="Disabled sunday dates"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn22">
            <wm-composite name="composite6_1">
                <wm-label class="col-md-3 control-label" notag="true" name="label13_1" caption="Label"></wm-label>
                <wm-container class="col-md-9" name="container6_1">
                    <wm-date name="date6_1" excludedays="0" placeholder="Select Date"></wm-date>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn23"></wm-gridcolumn>
    </wm-gridrow>
</wm-layoutgrid>`
    }
  },
  "wm-datetime": {
    "widgetType": "wm-datetime",
    "template": "<wm-datetime></wm-datetime>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls",
    "styleWorkspaceTemplates": {
      "customTemplate": [`<div style="display:flex; flex-direction:column; justify-content:space-between; gap:40px;">
      <div><div class="date-picker">
          <!-- Header -->
          <div class="date-picker__header">
            <h3 class="date-picker__title">Select Date</h3>
          </div>
          
          <!-- Date Picker Content -->
          <div class="date-picker__content">
            <div class="wheel-picker">
              <!-- Day Wheel -->
              <div class="wheel">
                <div class="wheel-scroll">
                  <div class="wheel-item">1</div>
                  <div class="wheel-item selected">2</div>
                  <div class="wheel-item">3</div>
                </div>
              </div>
              
              <!-- Month Wheel -->
              <div class="wheel">
                <div class="wheel-scroll">
                  <div class="wheel-item">Jan</div>
                  <div class="wheel-item selected">Feb</div>
                  <div class="wheel-item">Mar</div>
                </div>
              </div>
              
              <!-- Year Wheel -->
              <div class="wheel">
                <div class="wheel-scroll">
                  <div class="wheel-item">2023</div>
                  <div class="wheel-item selected">2024</div>
                  <div class="wheel-item">2025</div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="date-picker__actions">
            <button class="btn1 btn-cancel">Cancel</button>
            <button class="btn1 btn-select">Select</button>
          </div>
        </div></div>
      <div><div class="date-picker">
          <!-- Header -->
          <div class="date-picker__header">
            <h3 class="date-picker__title">Select Time</h3>
          </div>
          
          <!-- Date Picker Content -->
          <div class="date-picker__content">
            <div class="wheel-picker">
              <!-- Day Wheel -->
              <div class="wheel">
                <div class="wheel-scroll" style="width:100px; left:50px">
                  <div class="wheel-item" style="width:100px">9</div>
                  <div class="wheel-item selected" style="width:100px">10</div>
                  <div class="wheel-item" style="width:100px">11</div>
                </div>
              </div>
              
              <!-- Month Wheel -->
              <div class="wheel">
                <div class="wheel-scroll" style="width:100px; right:50px;">
                  <div class="wheel-item" style="width:100px">56</div>
                  <div class="wheel-item selected" style="width:100px">57</div>
                  <div class="wheel-item" style="width:100px">58</div>
                </div>
              </div>
              
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="date-picker__actions">
            <button class="btn1 btn-cancel">Cancel</button>
            <button class="btn1 btn-select">Select</button>
          </div>
          
        </div></div>
      </div>`],
    }
  },
  "wm-time": {
    "widgetType": "wm-time",
    "template": "<wm-time placeholder='Select time'></wm-time>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "form-controls", 
    styleWorkspaceTemplates : {
      usageTemplate : 
      `<wm-layoutgrid name="layoutgrid1" class="condensed gap-3">
    <wm-gridrow name="gridrow5" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn9">
            <wm-label padding="unset" class="p" type="p" caption="Caption Position" name="label7"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn10"></wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn11"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow4" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn12">
            <wm-label padding="unset" class="p" type="p" caption="default" name="label8"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn7">
            <wm-composite name="composite8_1">
                <wm-label class="col-md-3 control-label" notag="true" name="label16_1"></wm-label>
                <wm-container class="col-md-9" name="container8_1">
                    <wm-time name="time2" timepattern="hh:mm a" outputformat="hh:mm a" placeholder='Select time'></wm-time>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn8"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow2" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn13">
            <wm-label padding="unset" class="p" type="p" caption="left" name="label9"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn3">
            <wm-composite name="composite9_1" captionposition="left">
                <wm-label class="col-md-3 control-label" notag="true" name="label17"></wm-label>
                <wm-container class="col-md-9" name="container9_1">
                    <wm-time name="time3" placeholder='Select time'></wm-time>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn4"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow6" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn14">
            <wm-label padding="unset" class="p" type="p" caption="right" name="label11"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn17">
            <wm-composite name="composite10" captionposition="right">
                <wm-label class="col-md-3 control-label" notag="true" name="label18_1"></wm-label>
                <wm-container class="col-md-9" name="container10">
                    <wm-time name="time4" placeholder='Select time'></wm-time>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn15"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow3" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn18">
            <wm-label padding="unset" class="p" type="p" caption="top" name="label12"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn5">
            <wm-composite name="composite11_1" captionposition="top">
                <wm-label class="col-md-3 control-label" notag="true" name="label19"></wm-label>
                <wm-container class="col-md-9" name="container11_1">
                    <wm-time name="time5" placeholder='Select time'></wm-time>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn6"></wm-gridcolumn>
    </wm-gridrow>
    <wm-gridrow name="gridrow7" class="d-flex align-items-center">
        <wm-gridcolumn columnwidth="2" name="gridcolumn19">
            <wm-label padding="unset" class="p" type="p" caption="Floating" name="label14"></wm-label>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="4" name="gridcolumn20">
            <wm-composite name="composite12" captionposition="floating">
                <wm-label class="col-md-3 control-label" notag="true" name="label20"></wm-label>
                <wm-container class="col-md-9" name="container12">
                    <wm-time name="time6" placeholder='Select time'></wm-time>
                </wm-container>
            </wm-composite>
        </wm-gridcolumn>
        <wm-gridcolumn columnwidth="6" name="gridcolumn21"></wm-gridcolumn>
    </wm-gridrow>
</wm-layoutgrid>`
    }
  },
  "wm-fileupload": {
    "widgetType": "wm-fileupload",
    "template": "<wm-fileupload cleariconclass='wi wi-clear' cleariconhint='Clear'></wm-fileupload>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "fileupload", 
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1">
      <wm-gridrow name="gridrow1">
          <wm-gridcolumn columnwidth="12" name="gridcolumn2">
              <wm-label padding="12px unset 12px unset" class="p" type="p" name="label2"
                  caption="Single file upload"></wm-label>
              <wm-fileupload cleariconclass="wi wi-clear" cleariconhint="Clear" name="fileupload"
                  on-select="Variables.FileServiceUploadFile.invoke()" contenttype=".csv .docx .doc .jpg"
                  maxfilesize="10" iconclass="wi wi-upload" arialabel="Clear"></wm-fileupload>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow2">
          <wm-gridcolumn columnwidth="12" name="gridcolumn3">
              <wm-label padding="12px unset 12px unset" class="p" type="p" name="label2"
                  caption="Multi file upload"></wm-label>
              <wm-fileupload cleariconclass="wi wi-clear" cleariconhint="Clear" name="fileupload2"
                  on-select="Variables.FileServiceUploadFile1.invoke()" contenttype=".csv .docx .doc .jpg"
                  maxfilesize="10" multiple="true" iconclass="wi wi-upload" arialabel="Clear"></wm-fileupload>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`, 
  customTemplate : [`<wm-fileupload cleariconclass="wi wi-clear" cleariconhint="Clear" name="fileupload"
  on-select="Variables.FileServiceUploadFile.invoke()" contenttype=".csv .docx .doc .jpg"
  maxfilesize="10" iconclass="wi wi-upload" arialabel="Clear"></wm-fileupload>`],
     "platforms": {
        "native_mobile": {
          usageTemplate : `<wm-fileupload cleariconclass="wi wi-clear" cleariconhint="Clear" name="fileupload1" contenttype="image/*"
                on-select="Variables.FileServiceUploadFile.invoke()"
                on-delete="Variables.FileServiceDeleteFile.invoke()"></wm-fileupload>`
        }
      }
    }
  },
  "wm-progress-circle": {
    "widgetType": "wm-progress-circle",
    "template": "<wm-progress-circle width='150px' height='150px'></wm-progress-circle>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "progress-circle"
  },
  "wm-nav": {
    "widgetType": "wm-nav",
    "template":
      "<wm-nav type='pills' autoclose='outsideClick'>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 1'></wm-anchor>" +
      "</wm-nav-item>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 2'></wm-anchor>" +
      "</wm-nav-item>" +
      "<wm-nav-item>" +
      "<wm-anchor caption='Link 3'></wm-anchor>" +
      "</wm-nav-item>" +
      "</wm-nav>",
    "platforms": {
      "native_mobile": {
        "template":
          "<wm-nav type='pills' layout='stacked'  autoclose='outsideClick'>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 1'></wm-anchor>" +
          "</wm-nav-item>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 2'></wm-anchor>" +
          "</wm-nav-item>" +
          "<wm-nav-item>" +
          "<wm-anchor caption='Link 3'></wm-anchor>" +
          "</wm-nav-item>" +
          "</wm-nav>"
      }
    },
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false
  },
  "wm-nav-item": {
    "widgetType": "wm-nav-item",
    "template": "<wm-nav-item></wm-nav-item>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  "wm-navbar": {
    "widgetType": "wm-navbar",
    "template": "<wm-navbar title='Brand'>" +
      "<wm-nav type='navbar' class='navbar-left'>" +
      "<wm-nav-item><wm-anchor caption='Link 1'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 2'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 3'></wm-anchor></wm-nav-item>" +
      "</wm-nav>" +
      "<wm-nav type='navbar' class='navbar-right'>" +
      "<wm-nav-item><wm-anchor caption='Link 1'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 2'></wm-anchor></wm-nav-item>" +
      "<wm-nav-item><wm-anchor caption='Link 3'></wm-anchor></wm-nav-item>" +
      "</wm-nav>" +
      "</wm-navbar>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false
  },
  "wm-richtexteditor": {
    "widgetType": "wm-richtexteditor",
    "template": "<wm-richtexteditor></wm-richtexteditor>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "richtext-editor"
  },
  "wm-audio": {
    "widgetType": "wm-audio",
    "template": "<wm-audio controls='controls' audiopreload='none'></wm-audio>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "audio"
  },
  "wm-lottie": {
  "widgetType": "wm-lottie",
    "template": "<wm-lottie width=\"100%\" height=\"64px\"></wm-lottie>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "lottie",
    "styleWorkspaceTemplates": {
      platforms: {
        native_mobile: {
          customTemplate: [`<div style="background: #f2f2f2; padding-left: 140px; padding-top: 80px; padding-bottom: 10px; display: flex; height: 400px; width: 700px;"><wm-lottie height="250px" width="400px" name="lottie1"></wm-lottie></div>`]
        }
      }
    }
  },
  "wm-video": {
    "widgetType": "wm-video",
    "template": "<wm-video controls='controls' videopreload='none'></wm-video>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "video"
  },
  "wm-message": {
    "widgetType": "wm-message",
    "template": "<wm-message></wm-message>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "message",
       "styleWorkspaceTemplates":{
       platforms: {
        native_mobile: {
          customTemplate:[`<wm-message caption="Caption" type="Type" name="message01"></wm-message>`]
                 }
          }
    }
  },
  "wm-calendar": {
    "widgetType": "wm-calendar",
    "template": "<wm-calendar></wm-calendar>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "calendar", 
    // attributes: {
    //   width: "400px", 
    //   height: "400px", 
    //   datavalue: "bind:Variables.eventVariable.dataSet[$i].start",
    //   dataset: "bind:Variables.eventVariable.dataSet", 
    //    eventtitle:"title", 
    //   "on-eventclick" :"Widgets.dialog1.open();calendar1Eventclick($event, $data, $view)", 
    //   "on-beforerender" : "calendar1Beforerender($event, widget)", 
    //   "eventclass": "extendedProps.variant",
    // }
  },
  "wm-login": {
  "widgetType": "wm-login",
    "template":
  "<wm-login>" +
  "<wm-form>" +
  "<wm-composite> " +
  "<wm-label class='col-md-12 control-label' caption='Username'></wm-label> " +
  "<wm-container class='col-md-12'>" +
  "<wm-text placeholder='Enter username' name='j_username' class='app-login-username' updateon='default' required='true'></wm-text>" +
  "</wm-container> " +
  "</wm-composite> " +
  "<wm-composite> " +
  "<wm-label class='col-md-12 control-label' caption='Password'></wm-label> " +
  "<wm-container class='col-md-12'>" +
  "<wm-text type='password' name='j_password' placeholder='Enter password' class='app-login-password' updateon='default' required='true'></wm-text>" +
  "</wm-container>" +
  "</wm-composite> " +
  "<wm-button type='submit' caption='Sign in' width='100%' class='app-login-button btn-primary'></wm-button> " +
  "<wm-composite> " +
  "<wm-checkbox class='app-login-rememberme' scopedatavalue='user.rememberMe' caption='Remember Me' name='j_rememberme'></wm-checkbox> " +
  "</wm-composite> " +
  "</wm-form>" +
  "</wm-login>",
    "platforms" : {
    "mobile"  : {
      "template" :
      "<wm-login>" +
      "<wm-composite> " +
      "<wm-label class='col-xs-12 control-label' caption='Username'></wm-label> " +
      "<wm-container class='col-xs-12'>" +
      "<wm-text placeholder='Enter username' name='j_username' class='app-login-username' updateon='default'></wm-text>" +
      "</wm-container> " +
      "</wm-composite> " +
      "<wm-composite> " +
      "<wm-label class='col-xs-12 control-label' caption='Password'></wm-label> " +
      "<wm-container class='col-xs-12'>" +
      "<wm-text type='password' name='j_password' placeholder='Enter password' class='app-login-password' updateon='default'></wm-text>" +
      "</wm-container>" +
      "</wm-composite> " +
      "<wm-button type='submit' caption='Sign in' width='100%' class='app-login-button btn-primary'></wm-button> " +
      "<wm-composite> " +
      "<wm-checkbox class='app-login-rememberme' name='j_rememberme' scopedatavalue='user.rememberMe' caption='Remember Me'></wm-checkbox> " +
      "</wm-composite> " +
      "</wm-login>"
    },
    "native_mobile"  : {
      "template" :
      "<wm-login>" +
      "<wm-form>" +
      '<wm-layoutgrid>' +
      '<wm-gridrow>' +
      '<wm-gridcolumn columnwidth="12" xscolumnwidth="12">' +
      '<wm-form-field readonly="false" name="j_username" class="app-login-username" displayname="Username" key="j_username" type="string" show="true" widget="text" width="100%" placeholder="Enter username"></wm-form-field>' +
      '</wm-gridcolumn>' +
      '</wm-gridrow>' +
      '<wm-gridrow>' +
      '<wm-gridcolumn columnwidth="12" xscolumnwidth="12">' +
      '<wm-form-field readonly="false" name="j_password" class="app-login-password" displayname="Password" key="j_password" type="string" show="true" widget="text" inputtype="password" width="100%" placeholder="Enter password"></wm-form-field>' +
      '</wm-gridcolumn>' +
      '</wm-gridrow>' +
      '<wm-gridrow>' +
      '<wm-gridcolumn columnwidth="12" xscolumnwidth="12">' +
      '<wm-form-action key="signin" class="form-save btn-success" iconclass="wi wi-save" display-name="Signin" type="submit"></wm-form-action>' +
      '</wm-gridcolumn>' +
      '</wm-gridrow>' +
      '</wm-layoutgrid>' +
      "</wm-form>" +
      "</wm-login>"
    }
  },
  "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true,
    tokenFileName: "login"
},
"wm-carousel": {
    "widgetType": "wm-carousel",
    "template": "<wm-carousel height='480'>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "</wm-carousel>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    tokenFileName:"carousel",
    "config": {
      'requireVariable': false,
      'isLiveWidget': false,
      'title': 'Carousel',
      'screens': [
        {
          "id": 'grid-template',
          "label": "Select Data Grid Layout",
          "screen": "templateConfig",
          "description": "MESSAGE_TEMPLATE_SELECT_WIDGET",
          "liveWidgetId": "wm-table",
          "templates": [
            {
              "id": "static-carousel",
              "title": "Static Carousel",
              "platform": ["WEB", "MOBILE", "NATIVE_MOBILE"],
              "template": "<wm-carousel height='480'>" +
                "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
                "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
                "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
                "</wm-carousel>"
            },
            {
              "id": "dynamic-carousel",
              "title": "Dynamic Carousel",
              "platform": ["WEB", "MOBILE", "NATIVE_MOBILE"],
              "template": "<wm-carousel height='480' type='dynamic'>" +
                "<wm-carousel-template horizontalalign='center'><wm-picture width='100%'></wm-picture></wm-carousel-template>" +
                "</wm-carousel>"
            }
          ]
        }
      ]
    }, 
    styleWorkspaceTemplates : {
      customTemplate : ["<wm-carousel height='350' class='app-carousel'>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>" +
      "</wm-carousel>"]
    }
  },
  "wm-carousel-content": {
    "widgetType": "wm-carousel-content",
    "template": "<wm-carousel-content><wm-picture width='100%'></wm-picture></wm-carousel-content>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true
  },
  "wm-carousel-template": {
    "widgetType": "wm-carousel-template",
    "template": "<wm-carousel-template></wm-carousel-template>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isPageContainer": true
  },

  "wm-card": {
    "widgetType": "wm-card",
    "template": "<wm-list listclass='list-group' itemclass='list-group-item'><wm-listtemplate layout='panel' statehandler='URL'></wm-listtemplate></wm-list>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName": "cards",
    "config": {
      'requireVariable': true,
      'title': 'Cards',
      'bindTypes': ['wm-livefilter', 'wm-list', 'wm-table', 'wm-chart', 'wm-prefab'],
      'screens': [
        {
          "id": 'cards-config',
          "label": "Template",
          "screen": "templateConfig",
          "liveWidgetId": "wm-list",
          "description": "MESSAGE_WIDGET_SELECT_TEMPLATE",
          "templates": [
            {
              "id": "text-card",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Text Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-container direction="column" alignment="top-left" width="fill" name="container1">' +            
                '<wm-container direction="row" gap="auto" aligment="middle-center">' +
                '<wm-container flexgrow="1" width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-container>' +
                '<wm-container width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-container>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="unset 18px">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container' +
                '</wm-linearlayout>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-action-card",
              "title": "Text With Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": ' <wm-list listclass="list-group" template="true" template-name="Text with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-container direction="column" alignment="middle-left">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" margin="0px" class="h5" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer padding="16px 24px" horizontalalign="right">' +
                '<wm-container direction="column">' +
                '<wm-button class="btn-primary" textalign="center" caption="Action" padding="8px 24px"></wm-button>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-card",
              "title": "Media",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-container direction="column" alignment="middle-left">' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '<wm-container direction="column" alignment="middle-left" padding="24px">' +
                '<wm-container direction="row" gap="auto" alignment="middle-center">' +
                '<wm-container width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                 '</wm-container>' +
                '<wm-container width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px" iconposition="left"></wm-icon>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' + 
                '</wm-container>' + 
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-with-action-card",
              "title": "Media with Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-container direction="column" alignment="left-center">' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '<wm-container direction="column" alignment="left-center" padding="24px">' +
                '<wm-container direction="column" alignment="left-center" padding="24px">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '<wm-container padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer name="card_footer1" padding="16px 24px" horizontalalign="right">' +
                '<wm-container direction="row" gap="10">' +
                '<wm-button class="btn-primary" textalign="center" caption="Action1" padding="8px 24px"></wm-button>' +
                '<wm-button class="btn-secondary" textalign="center" caption="Action2" padding="8px 24px"></wm-button>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "bussiness-card",
              "title": "Business Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Business Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                '<wm-layoutgrid columns="2">' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="6" class="col-xs-6">' +
                '<wm-picture name="Picture" width="100%" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1"></wm-picture>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" columnwidth="6" padding="unset 1.25em" class="col-xs-6">' +
                '<wm-label name="ID" data-is-target caption="{}" class="text-muted p" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Name" data-is-target caption="{}" class="h4" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="h5" margin="0px unset unset unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Department" data-is-target caption="{}" class="p text-muted" name="label7" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Location" data-is-target caption="{}" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '<wm-anchor name="PhoneNumber" data-is-target caption="{}" class="h5" hyperlink="tel:" margin="0px unset" whitespace="nowrap"></wm-anchor>' +
                '<wm-anchor name="EmailID" class="p text-muted" hyperlink="mailto://" data-is-target caption="{}" whitespace="nowrap"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-card",
              "title": "Contact Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-4 md-6 lg-6" template="true" template-name="Contact Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="ContactCard">' +
                '<wm-card-content horizontalalign="center">' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="12" horizontalalign="center">' +
                '<wm-picture name="Picture" shape="circle" data-is-target picturesource="{}" width="60%"></wm-picture>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '<wm-label name="Name" class="h4 text-center" margin="unset unset 0em unset"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted  text-center" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "designation-card",
              "title": "Designation Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-3 md-4 lg-6" template="true" template-name="Designation Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" margin="0px unset" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "i-card",
              "title": "I Card",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="I Card" itemsperrow="xs-1 sm-2 md-4 lg-6" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label data-is-target caption="{}" name="Name" margin="0px unset unset unset"  class="h4" whitespace="nowrap"></wm-label>' +
                '<wm-layoutgrid columns="2">' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-contact-mail fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="ID" data-is-target caption="{}" fontunit="em" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-user fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="JobTitle" data-is-target caption="{}" fontunit="em" class="text-muted p"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn colwidth="6" columnwidth="2" horizontalalign="left">' +
                '<wm-icon iconclass="wi wi-dashboard fa-2x" class="text-muted"></wm-icon>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn colwidth="6" padding="unset unset unset 1.25em">' +
                '<wm-label name="Department" data-is-target caption="{}" fontunit="em" class="text-muted"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent text-muted" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-overview",
              "title": "Product Overview",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Overview" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" title="{}" subheading="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.5em unset unset unset">' +
                '<wm-button class="btn-fab btn-warning pull-right btn-lg" caption="" type="button" name="button2" iconclass="wi wi-cart" margin="-3.5em 0.5em unset unset"></wm-button>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="left" class="col-xs-6">' +
                '<wm-label name="Price"  data-is-target caption="{}" fontsize="1.286" fontunit="em"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-thumbnail",
              "title": "Product Thumbnail",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Thumbnail" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Thumbnail" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" data-is-target caption="{}" fontsize="1.286" fontunit="em" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="text-muted"></wm-label>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="left" class="col-xs-6">' +
                '<wm-label name="Currency" data-is-target caption="{}" color="#ba5d1e"></wm-label>' +
                '<wm-label name="Price" data-is-target caption="{}" fontsize="1.571" fontunit="em" color="#ba5d1e" margin="unset unset 1px unset"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-label name="Quantity" fontsize="1.286" fontunit="em" data-is-target caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="ADD TO CART" class="btn btn-transparent text-warning"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-inventory",
              "title": "Product Inventory",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Inventory" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" data-is-target caption="{}" margin="unset unset 0px unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-post",
              "title": "Media Post",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container>' +
                '<wm-container class="media-left" padding="unset unset unset 0.5em">' +
                '<wm-picture shape="circle" name="Avatar" data-is-target width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="h4" caption="{}" data-is-target name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '<wm-card name="Picture" data-is-target picturesource="{}">' +
                '<wm-card-content name="card_content1" padding="1.25em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" whitespace="nowrap" caption="{}" margin="unset unset 1em unset"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" class="col-xs-4">' +
                '<wm-anchor class="text-warning" caption="READ MORE"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="8" horizontalalign="right" class="col-xs-8">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "news-post",
              "title": "News Post",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="News Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container>' +
                '<wm-container class="media-left" padding="unset unset unset 0.5em">' +
                '<wm-picture shape="circle" data-is-target name="Avatar" width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="h4" data-is-target caption="{}" name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '<wm-card>' +
                '<wm-card-content padding="2em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" class="p" data-is-target caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" class="col-xs-4">' +
                '<wm-anchor caption="READ MORE"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="8" horizontalalign="right" class="col-xs-8">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="425" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-thumb-up fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "personal-spotlight",
              "title": "Personal Spotlight",
              "platform": ["WEB", "MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-1 sm-2 md-3 lg-4" template="true" template-name="Personal Spotlight"  class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.25em">' +
                '<wm-label name="Name" class="h4 text-muted" width="100%" data-is-target caption="{}" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Title" data-is-target caption="{}" class="h4" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Description" data-is-target caption="{}" class="p text-muted" margin="0px unset unset unset"></wm-label>' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
                '<wm-label name="Date" data-is-target caption="{}" class="text-muted" margin="0.6em unset unset unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="6" horizontalalign="right" class="col-xs-6">' +
                '<wm-anchor class="btn btn-transparent" iconclass="wi wi-comments fa-2x" caption="50"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-layoutgrid>' +
                '<wm-gridrow>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="left" class="col-xs-4">' +
                '<wm-anchor caption="75" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="center" class="col-xs-4">' +
                '<wm-anchor caption="425" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '<wm-gridcolumn columnwidth="4" horizontalalign="right" class="col-xs-4">' +
                '<wm-anchor caption="60" iconclass="wi wi-remove-red-eye fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-gridcolumn>' +
                '</wm-gridrow>' +
                '</wm-layoutgrid>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            }
          ]
        },
        {
          "id": 'card-fields',
          "label": "Bind Fields",
          "screen": "liveListFieldConfig",
          "description": "MESSAGE_WIDGET_MAP_FIELDS",
          "liveWidgetId": "wm-list"
        }
      ]
    }, 
    styleWorkspaceTemplates : {
      customTemplate : [`<wm-card name="card1">
                        <wm-card-content fontsize="0.8" fontunit="em" name="card_content1">
                            <wm-container direction="column" alignment="middle-center" gap="8" width="fill" wrap="false"
                                padding="12px" class="app-container-default" variant="default"
                                name="container8">
                                <wm-picture resizemode="cover" class="img-rounded" variant="default:rounded"
                                    width="100%" name="Picture"></wm-picture>
                                <wm-container direction="column" alignment="top-left" gap="4" width="fill" wrap="false"
                                    class="app-container-default" variant="default" name="container9">
                                    <wm-label padding="unset" caption="Title" class="h5 p" type="p" variant="default:p"
                                        show="true" required="required" name="Title"></wm-label>
                                    <wm-label padding="unset" caption="Body" class="p" type="p" variant="default:p"
                                        show="true" required="required" name="Body"></wm-label>
                                </wm-container>
                                <wm-container direction="row" alignment="middle-right" gap="4" width="fill"
                                    class="app-container-default" variant="default" height="hug" name="container10">
                                    <wm-button class="btn-filled btn-default" caption="Button" type="button"
                                        margin="unset" variant="filled:default" name="button5"></wm-button>
                                    <wm-button class="btn-filled btn-primary" caption="Button" type="button"
                                        margin="unset" variant="filled:primary" name="button6"></wm-button>
                                </wm-container>
                            </wm-container>
                        </wm-card-content>
                    </wm-card>`], 
      platforms: {
        native_mobile: {
          customTemplate: [`<wm-card name="card1" iconclass="wm-sl-l sl-more-menu-vertical" height="160px" width="360px" style="margin-right : 80px;">
                        <wm-card-content padding="0px" name="card_content1">
                            <wm-linearlayout direction="column" horizontalalign="left" verticalalign="center"
                                name="linearlayout1">
                            </wm-linearlayout>
                            <wm-linearlayout direction="column" horizontalalign="left" verticalalign="center"
                                padding="24px" name="linearlayout2">
                                <wm-linearlayoutitem name="linearlayoutitem2">
                                </wm-linearlayoutitem>
                                <wm-linearlayoutitem padding="18px unset unset unset" name="linearlayoutitem4">
                                </wm-linearlayoutitem>
                                <wm-linearlayoutitem padding="4px unset unset unset" name="linearlayoutitem5">
                                </wm-linearlayoutitem>
                            </wm-linearlayout>
                        </wm-card-content>
                        <wm-card-footer name="card_footer1" padding="16px 24px" horizontalalign="right" style="border-top : 0px;">
                            <wm-linearlayout direction="row" spacing="10" name="linearlayout3" display="flex" flexdirection="row" alignitems="flex-end" justifycontent="space-around" style=" gap:40px ">
                            </wm-linearlayout>
                        </wm-card-footer>
                    </wm-card>`],
        }
      },
    }
  },
  "wm-breadcrumb": {
    "widgetType": "wm-breadcrumb",
    "template": "<wm-breadcrumb dataset='Home, Page' class='path-based'></wm-breadcrumb>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "isLayoutBundled": true,
    "isPageContainer": false,
    "tokenFileName":"breadcrumb", 
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1">
      <wm-gridrow name="gridrow5">
          <wm-gridcolumn columnwidth="2" name="gridcolumn8_1">
              <wm-label padding="unset" class="p" type="p" caption="Type" name="label5"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn9"></wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow2">
          <wm-gridcolumn columnwidth="2" name="gridcolumn3">
              <wm-label padding="unset" class="h6" type="h6" name="label2" caption="Arrow"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn4">
              <wm-breadcrumb dataset="bind:Variables.stvBreadCrumb.dataSet" class="path-based" name="breadcrumb4_1" itemlabel="label" itemicon="icon"></wm-breadcrumb>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow3">
          <wm-gridcolumn columnwidth="2" name="gridcolumn5">
              <wm-label padding="unset" class="h6" type="h6" name="label3" caption="Classic 1"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn6">
              <wm-breadcrumb dataset="bind:Variables.stvBreadCrumb.dataSet" class="classic" name="breadcrumb2"></wm-breadcrumb>
          </wm-gridcolumn>
      </wm-gridrow>
      <wm-gridrow name="gridrow4">
          <wm-gridcolumn columnwidth="2" name="gridcolumn7">
              <wm-label padding="unset" class="h6" type="h6" name="label4" caption="Classic 2"></wm-label>
          </wm-gridcolumn>
          <wm-gridcolumn columnwidth="10" name="gridcolumn8">
              <wm-breadcrumb dataset="bind:Variables.stvBreadCrumb.dataSet" class="attribute-based" name="breadcrumb4"></wm-breadcrumb>
          </wm-gridcolumn>
      </wm-gridrow>
  </wm-layoutgrid>`, 
    },
  },
  "wm-colorpicker": {
    "widgetType": "wm-colorpicker",
    "template": "<wm-colorpicker></wm-colorpicker>",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"color-picker"
  },
  "wm-iframe": {
    "widgetType": "wm-iframe",
    "template": "<wm-iframe></wm-iframe>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"iframe"
  },
  "wm-webview":{
    "widgetType": "wm-webview",
    "template": "<wm-webview height='150px' width='300px'></wm-webview>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    tokenFileName: "webview",
    styleWorkspaceTemplates: {
      platforms: {
        "native_mobile": {
          customTemplate: [`<div style="padding-left: 140px; padding-top: 80px; padding-bottom: 10px; display: flex; background: #f2f2f2; height: 400px; width: 700px;"><wm-webview height='250px' width='400px'></wm-webview></div>`],
        }
      }
    }
  },
  "wm-popover": {
    "widgetType": "wm-popover",
    "template": "<wm-popover popoverwidth='240' popoverheight='360' margin='unset 0.5em'></wm-popover>",
    "platforms": {
      "native_mobile": {
        "template": "<wm-popover popoverwidth='240' popoverheight='360' margin='unset 4px'></wm-popover>"
      }
    },
    tokenFileName:"popover",
    "isContainer": false,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "isPageContainer": true,
    "styleWorkspaceTemplates":{
      "platforms": {
        "native_mobile": {
          "customTemplate": [`<wm-popover popoverwidth="240" popoverheight="360" margin="unset 4px" name="popover1"
                iconclass="wm-sl-l sl-google"></wm-popover>`]
    }
  }
  }
},

  "wm-filter-field": {
    "widgetType": "wm-filter-field",
    "template": "<wm-filter-field></wm-filter-field>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },

  "wm-marquee": {
    "widgetType": "wm-marquee",
    "template": "<wm-marquee></wm-marquee>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": true,
    "isDeletable": true,
    "canBeCopied": true
  },

  "wm-custom": {
    "widgetType": "wm-custom",
    "template": "<wm-custom></wm-custom>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },

  "wm-livetable": {
    "widgetType": "wm-livetable",
    "template":
      '<wm-livetable>' +
      '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
      '<wm-liveform  errormessage="" title="Details" formlayout="inline"  iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
      '</wm-livetable>',
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false,
    "config": {
      'requireVariable': false,
      'isLiveWidget': true,
      'title': 'Live Widget',
      'bindTypes': [],
      'screens': [
        {
          "id": 'livewidget-layout',
          "label": "Live Widget Layout",
          "labelKey": "LABEL_LIVE_WIDGET_LAYOUT",
          "screen": "templateConfig",
          "description": "MESSAGE_LIVE_WIDGET_CONFIG",
          "templates": [
            {
              "id": "grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB"],
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB"],
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB"],
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form-filter",
              "title": "Filter with Grid and Form",
              "labelKey": "LABEL_FILTER_WITH_GRID_AND_FORM",
              "platform": ["WEB"],
              "template":
                '<wm-livetable>' +
                '<wm-livefilter><wm-layoutgrid></wm-layoutgrid></wm-livefilter>' +
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "list-form-web",
              "title": "List with Form",
              "labelKey": "LABEL_LIST_WITH_FORM",
              "platform": ["WEB"],
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "list-form-device",
              "title": "List with Form",
              "labelKey": "LABEL_LIST_WITH_FORM",
              "platform": ["MOBILE"],
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>' +
                '</wm-livetable>'
            }
          ]
        }
      ]
    }
  },
  "wm-chart": {
    "widgetType": "wm-chart",
    "template": "<wm-chart title='Chart'></wm-chart>",
    "isContainer": false,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true
  },
  "wm-chart-line": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Line' title='Line Chart' height='250px' iconclass='wi wi-line-chart'></wm-chart>"
  },
  "wm-chart-column": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Column' title='Column Chart' height='250px' iconclass='wi wi-bar-chart'></wm-chart>"
  },
  "wm-chart-pie": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Pie' title='Pie Chart' height='250px' iconclass='wi wi-pie-chart'></wm-chart>"
  },
  "wm-chart-area": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Area' title='Area Chart' height='250px' iconclass='fa fa-area-chart'></wm-chart>"
  },
  "wm-chart-bar": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Bar' title='Bar Chart' height='250px' iconclass='wi wi-bar-chart'></wm-chart>"
  },
  "wm-chart-cumulativeline": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Cumulative Line' title='Cumulative Line Chart' height='250px' iconclass='wi wi-line-chart'></wm-chart>"
  },
  "wm-chart-donut": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Donut' title='Donut Chart' height='250px' iconclass='wi wi-donut-large'></wm-chart>"
  },
  "wm-chart-bubble": {
    "widgetType": "wm-chart",
    "template": "<wm-chart type='Bubble' title='Bubble Chart' height='250px' iconclass='wi wi-bubble-chart'></wm-chart>"
  },
  "wm-dialog": {
    "widgetType": "wm-dialog",
    "template": "<wm-dialog></wm-dialog>",
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": true,
    "tokenFileName": "modal-dialog",
    "styleWorkspaceTemplates": {
      "platforms": {
        "native_mobile": {
          "customTemplate": [
            `
            <div style="flex:1">
            <div class="dialog-container" style="margin-bottom:20px">
              <div class="native_mobile-dialog">
                <div class="dialog-content">
                  <div class="dialog-header">
                    <span class="dialog-icon"><i class="wi wi-check"></i></span>
                    <h4 class="dialog-title">Confirmation</h4>
                    <div class="dialog-close">
                      <i class="wi wi-close"></i>
                    </div>
                  </div>
                  <div class="dialog-message">
                    Are you sure you want to continue?
                  </div>
                </div>
                <div class="dialog-actions" style="display: flex; width: 100%;">
                  <button class="dialog-btn cancel-btn" style="flex: 1; background: none; border: none; border-right: 0px solid #ddd; padding: 12px; margin: 0; color: #333; text-align: center;">Cancel</button>
                  <button class="dialog-btn confirm-btn" style="flex: 1; background: none; border: none; padding: 12px; margin: 0; color: #1976d2; text-align: center;">OK</button>
                </div>
              </div>
            </div>
            <div class="dialog-container" style="margin-bottom:20px;">
              <div class="native_mobile-dialog alert-dialog">
                <div class="dialog-content">
                  <div class="dialog-header">
                    <span class="dialog-icon alert-icon"><i class="wi wi-alert"></i></span>
                    <h4 class="dialog-title">Alert</h4>
                    <div class="dialog-close">
                      <i class="wi wi-close"></i>
                    </div>
                  </div>
                  <div class="dialog-message">
                    I am Alert box!
                  </div>
                </div>
                <div class="dialog-actions" style="width:100%;  padding-left:40px; padding-right:40px;">
                  <button class="dialog-btn confirm-btn" style="width:100%">OK</button>
                </div>
              </div>
            </div>
            <div class="dialog-container">
              <div class="native_mobile-dialog design-dialog">
                <div class="dialog-header">
                  <span class="dialog-icon"><i class="wi wi-file"></i></span>
                  <h4 class="dialog-title">Design Dialog</h4>
                  <div class="dialog-close">
                    <i class="wi wi-close"></i>
                  </div>
                </div>
                <div class="dialog-content"> 
                </div>
                <div class="dialog-divider"></div>
                <div class="dialog-actions">
                  <button class="dialog-btn confirm-btn">Close</button>
                </div>
              </div>
            </div>
            </div>`
          ]
        }
      }
    }
  },
  "wm-dialogactions": {
    "widgetType": "wm-dialogactions",
    "template": "<wm-dialogactions></wm-dialogactions>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": true,
    "isDroppable": true
  },
  "wm-logindialog": {
    "widgetType": "wm-logindialog",
    "template":
      "<wm-logindialog modal='false' caption='Login' iconclass='wi wi-sign-in'>" +
      "<wm-form errormessage='' captionposition='top'>" +
      "<wm-message scopedataset='loginMessage' class='app-login-dialog-message'></wm-message>" +
      "<wm-composite>" +
      "<wm-label caption='Username' class='col-md-3 control-label'></wm-label>" +
      "<wm-container class='col-md-9'><wm-text placeholder='Enter username' class='app-login-dialog-username' name='j_username' updateon='default'></wm-text></wm-container>" +
      "</wm-composite>" +
      "<wm-composite>" +
      "<wm-label caption='Password'  class='col-md-3 control-label'></wm-label>" +
      "<wm-container class='col-md-9'><wm-text type='password' placeholder='Enter password' class='app-login-dialog-password' name='j_password' updateon='default'></wm-text></wm-container>" +
      "</wm-composite>" +
      "</wm-form>" +
      "<wm-dialogactions>" +
      "<wm-button class='btn-primary' caption='Sign in' data-role='loginbutton'></wm-button>" +
      "</wm-dialogactions>" +
      "</wm-logindialog>",
    "platforms": {
      "mobile": {
        "template":
          "<wm-logindialog modal='false' caption='Login' iconclass='wi wi-sign-in'>" +
          "<wm-form errormessage='' captionposition='top'>" +
          "<wm-message scopedataset='loginMessage' class='app-login-dialog-message'></wm-message>" +
          "<wm-composite>" +
          "<wm-label caption='Username' class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'><wm-text placeholder='Enter username' class='app-login-dialog-username' name='j_username' updateon='default'></wm-text></wm-container>" +
          "</wm-composite>" +
          "<wm-composite>" +
          "<wm-label caption='Password'  class='col-xs-4 control-label'></wm-label>" +
          "<wm-container class='col-xs-8'><wm-text type='password' placeholder='Enter password' class='app-login-dialog-password' name='passwordtext' updateon='default'></wm-text></wm-container>" +
          "</wm-composite>" +
          "</wm-form>" +
          "<wm-dialogactions>" +
          "<wm-button class='btn-primary' caption='Sign in' data-role='loginbutton'></wm-button>" +
          "</wm-dialogactions>" +
          "</wm-logindialog>"
      }
    },
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": false,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "tokenFileName":"modal-dialog"
  },
  "wm-iframedialog": {
    "widgetType": "wm-iframedialog",
    "template": '<wm-iframedialog on-ok="$wm-expr(\'Widgets.\' + name + \'.close()\')"></wm-iframedialog>',
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "tokenFileName":"modal-dialog"
  },
  "wm-confirmdialog": {
    "widgetType": "wm-confirmdialog",
    "template": '<wm-confirmdialog on-ok="$wm-expr(\'Widgets.\' + name + \'.close()\')" on-cancel="$wm-expr(\'Widgets.\' + name + \'.close()\')"></wm-confirmdialog>',
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "tokenFileName":"modal-dialog"
  },
  "wm-alertdialog": {
    "widgetType": "wm-alertdialog",
    "template": '<wm-alertdialog on-ok="$wm-expr(\'Widgets.\'+ name +\'.close()\')"></wm-alertdialog>',
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "tokenFileName":"modal-dialog"
  },
  "wm-pagedialog": {
    "widgetType": "wm-pagedialog",
    "template": '<wm-pagedialog on-ok="$wm-expr(\'Widgets.\' + name + \'.close()\')"></wm-pagedialog>',
    "isContainer": true,
    "isResizable": true,
    "isMovableInsideCanvas": true,
    "isDeletable": true,
    "canBeCopied": false,
    "isDroppable": false,
    "isPageContainer": true
  },
  "wm-design-dialog": {
    "widgetType": "wm-design-dialog",
    "template":
      '<wm-dialog dialogtype="design-dialog" modal="true" title="Information" iconclass="wi wi-file-text">' +
      '<wm-layoutgrid>' +
      '<wm-gridrow>' +
      '<wm-gridcolumn columnwidth="6">' +
      '<wm-label padding="unset 0.5em" caption="Name"></wm-label>' +
      '</wm-gridcolumn>' +
      '<wm-gridcolumn columnwidth="6">' +
      '<wm-label padding="unset 0.5em" caption="Eric"></wm-label>' +
      '</wm-gridcolumn>' +
      '</wm-gridrow>' +
      '<wm-gridrow>' +
      '<wm-gridcolumn columnwidth="6">' +
      '<wm-label padding="unset 0.5em" caption="Title"></wm-label>' +
      '</wm-gridcolumn>' +
      '<wm-gridcolumn columnwidth="6">' +
      '<wm-label padding="unset 0.5em" caption="Engineer"></wm-label>' +
      '</wm-gridcolumn>' +
      '</wm-gridrow>' +
      '</wm-layoutgrid>' +
      '<wm-dialogactions>' +
      '<wm-button class="btn-primary" caption="Close" on-click="closeDialog()"></wm-button>' +
      '</wm-dialogactions>' +
      '</wm-dialog>',
    "platforms": {
      "native_mobile": {
        "template":
          "<wm-dialog dialogtype='design-dialog' type='page' modal='true' title='Information' iconclass='wi wi-file-text'>" +
          '<wm-layoutgrid>' +
          '<wm-gridrow>' +
          '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
          '<wm-label padding="unset 0.5em" caption="Name"></wm-label>' +
          '</wm-gridcolumn>' +
          '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
          '<wm-label padding="unset 0.5em" caption="Eric"></wm-label>' +
          '</wm-gridcolumn>' +
          '</wm-gridrow>' +
          '<wm-gridrow>' +
          '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
          '<wm-label padding="unset 0.5em" caption="Title"></wm-label>' +
          '</wm-gridcolumn>' +
          '<wm-gridcolumn columnwidth="6" class="col-xs-6">' +
          '<wm-label padding="unset 0.5em" caption="Engineer"></wm-label>' +
          '</wm-gridcolumn>' +
          '</wm-gridrow>' +
          '</wm-layoutgrid>' +
          "<wm-dialogactions>" +
          "<wm-button class='btn-primary' caption='Close' on-click='closeDialog()'></wm-button>" +
          "</wm-dialogactions>" +
          "</wm-dialog>"
      }
    },
    "tokenFileName":"modal-dialog"
  },
  "wm-spinner": {
    "widgetType": "wm-spinner",
    "template": "<wm-spinner show='true'></wm-spinner>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": true,
    "tokenFileName":"spinner",
    styleWorkspaceTemplates: {
      customTemplate: [`
      <div style="height:100px;"><wm-spinner show='true'></wm-spinner></div>`]
    }
  }, 
  "wm-toggle" : {
    widgetType : "wm-checkbox", 
    template : `<wm-checkbox type="toggle" datavalue="false"></wm-checkbox>`,
    styleWorkspaceTemplates : {
      usageTemplate : `<wm-layoutgrid name="layoutgrid1">
      <wm-gridrow name="gridrow2">
          <wm-composite name="composite1" captionposition="top">
              <wm-label class="col-md-3 control-label" notag="true" name="label2" caption="Toggle - Unchecked"></wm-label>
              <wm-container class="col-md-9" name="container1">
                  <wm-checkbox caption="Toggle" type="toggle" name="toggle1" disabled="false" required="true"
                      uncheckedvalue="false" checkedvalue="true" datavalue="false"></wm-checkbox>
              </wm-container>
          </wm-composite>
      </wm-gridrow>
      <wm-gridrow>
          <wm-composite name="composite1" captionposition="top">
              <wm-label class="col-md-3 control-label" notag="true" name="label2" caption="Toggle - Checked"></wm-label>
              <wm-container class="col-md-9" name="container1">
                  <wm-checkbox value="true" caption="Toggle" type="toggle" name="toggle1" disabled="false" required="true"
                      uncheckedvalue="false" checkedvalue="true" datavalue="true"></wm-checkbox>
              </wm-container>
          </wm-composite>
      </wm-gridrow>
  </wm-layoutgrid>`,
    }
  }
};


export function addSubGroups(wpProvider: WidgetPropertiesProvider) {
    wpProvider.addSubGroup(
    {
      "name": "commonWidgets",
      "namekey": "LABEL_WIDGETS_COMMONLY_USED",
      "parent": "widgets",
      "feature": "components.widgets.commonWidgets",
      "widgets": [
        {
          "widgetType": "wm-label",
          "name": "Label",
          "namekey": "LABEL_WIDGET_LABEL",
          "iconclass": "label",
          "feature": "components.widgets.commonWidgets.label",
          "apiDocLink": "classes/Label.html",
          "widgetDocLink": "basic/label",
          "keywords": "label",
          "dropEffectCls": "wm-label inline"
        },
        {
          "widgetType": "wm-button",
          "name": "Button",
          "namekey": "LABEL_WIDGET_BUTTON",
          "iconclass": "button",
          "keywords": "button",
          "feature": "components.widgets.formWidgets.button",
          "apiDocLink": "classes/Button.html",
          "widgetDocLink": "form-widgets/button",
          "dropEffectCls": "wm-button inline"
        },
        {
          "widgetType": "wm-anchor",
          "name": "Anchor",
          "namekey": "LABEL_WIDGET_ANCHOR",
          "iconclass": "anchor",
          "feature": "components.widgets.basicWidgets.anchor",
          "apiDocLink": "classes/Anchor.html",
          "widgetDocLink": "basic/anchor",
          "keywords": "anchor",
          "dropEffectCls": "wm-anchor inline"
        },
        {
          "widgetType": "wm-icon",
          "name": "Icon",
          "namekey": "LABEL_WIDGET_ICON",
          "iconclass": "icon",
          "feature": "components.widgets.basicWidgets.icon",
          "apiDocLink": "classes/Icon.html",
          "widgetDocLink": "basic/icon",
          "keywords": "icon",
          "dropEffectCls": "wm-icon inline"
        },
        {
        "widgetType": "wm-container",
        "name": "Container",
        "namekey": "LABEL_WIDGET_CONTAINER",
        "iconclass": "container",
        "feature": "components.layouts.container.container",
        "apiDocLink": "classes/Container.html",
        "widgetDocLink": "container/",
        "dropEffectCls": "wm-container block"
      }
      ]
    }
  );
  wpProvider.addSubGroup(
    {
      "name": "formwidgets",
      "namekey": "LABEL_WIDGETS_FORMWIDGETS",
      "parent": "widgets",
      "feature": "components.widgets.formWidgets",
      "widgets": [
        {
          "widgetType": "wm-button",
          "name": "Button",
          "namekey": "LABEL_WIDGET_BUTTON",
          "iconclass": "button",
          "keywords": "button",
          "feature": "components.widgets.formWidgets.button",
          "apiDocLink": "classes/Button.html",
          "widgetDocLink": "form-widgets/button",
          "dropEffectCls": "wm-button inline"
        },
        {
          "widgetType": "wm-buttongroup",
          "name": "Button Group",
          "namekey": "LABEL_WIDGET_BUTTON_GROUP",
          "iconclass": "button-group",
          "keywords": "button, buttongroup, button group",
          "feature": "components.widgets.formWidgets.buttonGroup",
          "apiDocLink": "classes/ButtonGroup.html",
          "widgetDocLink": "form-widgets/button-group",
          "dropEffectCls": "wm-buttongroup inline"
        },
        {
          "widgetType": "wm-composite-text",
          "name": "Text",
          "namekey": "LABEL_WIDGET_TEXT",
          "iconclass": "text",
          "keywords": "text",
          "feature": "components.widgets.formWidgets.text",
          "apiDocLink": "classes/Text.html",
          "widgetDocLink": "form-widgets/text",
          "dropEffectCls": "wm-composite-text block"
        },
        {
          "widgetType": "wm-composite-number",
          "name": "Number",
          "namekey": "LABEL_WIDGET_NUMBER",
          "iconclass": "number",
          "keywords": "text",
          "feature": "components.widgets.formWidgets.number",
          "apiDocLink": "classes/Number.html",
          "widgetDocLink": "form-widgets/number",
          "dropEffectCls": "wm-composite-text block"
        },
        {
          "widgetType": "wm-composite-textarea",
          "name": "Textarea",
          "namekey": "LABEL_WIDGET_TEXTAREA",
          "iconclass": "textarea",
          "keywords": "text, textarea, text area",
          "feature": "components.widgets.formWidgets.textarea",
          "apiDocLink": "classes/Textarea.html",
          "widgetDocLink": "form-widgets/textarea",
          "dropEffectCls": "wm-composite-textarea block"
        },
        {
          "widgetType": "wm-composite-select",
          "name": "Select",
          "namekey": "LABEL_WIDGET_SELECT",
          "iconclass": "select",
          "keywords": "select",
          "feature": "components.widgets.formWidgets.select",
          "apiDocLink": "classes/Select.html",
          "widgetDocLink": "form-widgets/select",
          "dropEffectCls": "wm-composite-select block"
        },
        {
          "widgetType": "wm-chips",
          "name": "Chips",
          "namekey": "LABEL_WIDGET_CHIPS",
          "iconclass": "chips",
          "keywords": "chips",
          "feature": "components.widgets.formWidgets.chips",
          "apiDocLink": "classes/Chips.html",
          "widgetDocLink": "form-widgets/chips",
          "dropEffectCls": "wm-chips block"
        },
        {
          "widgetType": "wm-composite-currency",
          "name": "Currency",
          "namekey": "LABEL_WIDGET_CURRENCY",
          "iconclass": "currency",
          "keywords": "currency",
          "feature": "components.widgets.formWidgets.currency",
          "apiDocLink": "classes/Currency.html",
          "widgetDocLink": "form-widgets/currency",
          "dropEffectCls": "wm-composite-currency block"
        },
        {
          "widgetType": "wm-composite-radio",
          "name": "Radio",
          "namekey": "LABEL_WIDGET_RADIO",
          "iconclass": "radio",
          "keywords": "radio",
          "feature": "components.widgets.formWidgets.radio",
          "dropEffectCls": "wm-composite-radio block"
        },
        {
          "widgetType": "wm-composite-radioset",
          "name": "Radioset",
          "namekey": "LABEL_WIDGET_RADIOSET",
          "iconclass": "radioset",
          "keywords": "radioset",
          "feature": "components.widgets.formWidgets.radioSet",
          "apiDocLink": "classes/Radioset.html",
          "widgetDocLink": "form-widgets/radioset",
          "dropEffectCls": "wm-composite-radioset block"
        },
        {
          "widgetType": "wm-composite-checkbox",
          "name": "Checkbox",
          "namekey": "LABEL_WIDGET_CHECKBOX",
          "iconclass": "checkbox",
          "keywords": "checkbox",
          "feature": "components.widgets.formWidgets.checkbox",
          "apiDocLink": "classes/Checkbox.html",
          "widgetDocLink": "form-widgets/checkbox",
          "dropEffectCls": "wm-composite-checkbox block"
        },
        {
          "widgetType": "wm-composite-checkboxset",
          "name": "Checkboxset",
          "namekey": "LABEL_WIDGET_CHECKBOXSET",
          "iconclass": "checkboxset",
          "keywords": "checkboxset",
          "feature": "components.widgets.formWidgets.checkboxSet",
          "apiDocLink": "classes/Checkboxset.html",
          "widgetDocLink": "form-widgets/checkboxset",
          "dropEffectCls": "wm-composite-checkboxset block"
        },
        {
          "widgetType": "wm-composite-toggle",
          "name": "Toggle",
          "namekey": "LABEL_WIDGET_TOGGLE",
          "iconclass": "toggle",
          "keywords": "toggle",
          "feature": "components.widgets.formWidgets.checkbox",
          "apiDocLink": "classes/Toggle.html",
          "widgetDocLink": "form-widgets/toggle",
          "dropEffectCls": "wm-composite-toggle block"
        },
        {
          "widgetType": "wm-iconbutton-toggle",
          "name": "Icon button toggle",
          "namekey": "LABEL_WIDGET_ICON_BUTTON_TOGGLE",
          "iconclass": "button",
          "keywords": "iconbuttontoggleable",
          "feature": "components.widgets.formWidgets.iconButtonToggleable",
          "apiDocLink": "classes/Toggle.html",
          "widgetDocLink": "form-widgets/toggle",
          "dropEffectCls": "wm-iconbutton-toggle block"
        },
        {
          "widgetType": "wm-composite-switch",
          "name": "Switch",
          "namekey": "LABEL_WIDGET_SWITCH",
          "iconclass": "switch",
          "keywords": "switch",
          "feature": "components.widgets.formWidgets.switch",
          "apiDocLink": "classes/Switch.html",
          "widgetDocLink": "form-widgets/switch",
          "dropEffectCls": "wm-composite-switch block"
        },
        {
          "widgetType": "wm-composite-date",
          "name": "Date",
          "namekey": "LABEL_WIDGET_DATE",
          "iconclass": "date",
          "keywords": "date",
          "feature": "components.widgets.formWidgets.date",
          "apiDocLink": "classes/Date.html",
          "widgetDocLink": "form-widgets/date-time-datetime",
          "dropEffectCls": "wm-composite-date block"
        },
        {
          "widgetType": "wm-calendar",
          "name": "Calendar",
          "namekey": "LABEL_WIDGET_CALENDAR",
          "iconclass": "calendar",
          "keywords": "calendar",
          "feature": "components.widgets.formWidgets.calendar",
          "apiDocLink": "classes/Calendar.html",
          "widgetDocLink": "form-widgets/calendar",
          "dropEffectCls": "wm-calendar block"
        },
        {
          "widgetType": "wm-composite-time",
          "name": "Time",
          "namekey": "LABEL_WIDGET_TIME",
          "iconclass": "time",
          "keywords": "time",
          "feature": "components.widgets.formWidgets.time",
          "apiDocLink": "classes/Time.html",
          "widgetDocLink": "form-widgets/date-time-datetime",
          "dropEffectCls": "wm-composite-time block"
        },
        {
          "widgetType": "wm-composite-datetime",
          "name": "Datetime",
          "namekey": "LABEL_WIDGET_DATETIME",
          "iconclass": "datetime",
          "keywords": "date, datetime, date time",
          "feature": "components.widgets.formWidgets.datetime",
          "apiDocLink": "classes/Datetime.html",
          "widgetDocLink": "form-widgets/date-time-datetime",
          "dropEffectCls": "wm-composite-datetime block"
        },
        {
          "widgetType": "wm-fileupload",
          "name": "Fileupload",
          "namekey": "LABEL_WIDGET_FILEUPLOAD",
          "iconclass": "fileupload",
          "keywords": "fileupload",
          "feature": "components.widgets.formWidgets.fileUpload",
          "apiDocLink": "classes/FileUpload.html",
          "widgetDocLink": "form-widgets/file-upload",
          "dropEffectCls": "wm-fileupload block"
        },
        {
          "widgetType": "wm-composite-colorpicker",
          "name": "Colorpicker",
          "namekey": "LABEL_WIDGET_COLORPICKER",
          "iconclass": "colorpicker",
          "keywords": "colorpicker",
          "feature": "components.widgets.formWidgets.colorPicker",
          "apiDocLink": "classes/ColorPicker.html",
          "widgetDocLink": "form-widgets/color-picker",
          "dropEffectCls": "wm-composite-colorpicker block"
        },
        {
          "widgetType": "wm-composite-slider",
          "name": "slider",
          "namekey": "LABEL_WIDGET_SLIDER",
          "iconclass": "slider",
          "keywords": "slider",
          "feature": "components.widgets.formWidgets.slider",
          "apiDocLink": "classes/Slider.html",
          "widgetDocLink": "form-widgets/slider",
          "dropEffectCls": "wm-composite-slider block"
        },
        {
          "widgetType": "wm-rating",
          "name": "Rating",
          "namekey": "LABEL_WIDGET_RATING",
          "iconclass": "rating",
          "keywords": "rating",
          "feature": "components.widgets.advancedWidgets.rating",
          "apiDocLink": "classes/Rating.html",
          "widgetDocLink": "form-widgets/rating-widget",
          "dropEffectCls": "wm-rating inline"
        },
        {
          "widgetType": "wm-composite-selectlocale",
          "name": "Select Locale",
          "namekey": "LABEL_WIDGET_SELECTLOCALE",
          "iconclass": "selectlocale",
          "keywords": "locale, select locale, selectlocale",
          "feature": "components.widgets.basicWidgets.locale",
          "apiDocLink": "classes/Select.html",
          "widgetDocLink": "form-widgets/select-locale",
          "dropEffectCls": "wm-composite-selectlocale inline"
        }
      ]
    }
  );

  wpProvider.addSubGroup(
    {
      "name": "basicwidgets",
      "namekey": "LABEL_WIDGETS_BASICWIDGETS",
      "parent": "widgets",
      "feature": "components.widgets.basicWidgets",
      "widgets": [
        {
          "widgetType": "wm-label",
          "name": "Label",
          "namekey": "LABEL_WIDGET_LABEL",
          "iconclass": "label",
          "feature": "components.widgets.basicWidgets.label",
          "apiDocLink": "classes/Label.html",
          "widgetDocLink": "basic/label",
          "keywords": "label",
          "dropEffectCls": "wm-label inline"
        },
        {
          "widgetType": "wm-anchor",
          "name": "Anchor",
          "namekey": "LABEL_WIDGET_ANCHOR",
          "iconclass": "anchor",
          "feature": "components.widgets.basicWidgets.anchor",
          "apiDocLink": "classes/Anchor.html",
          "widgetDocLink": "basic/anchor",
          "keywords": "anchor",
          "dropEffectCls": "wm-anchor inline"
        },
        {
          "widgetType": "wm-icon",
          "name": "Icon",
          "namekey": "LABEL_WIDGET_ICON",
          "iconclass": "icon",
          "feature": "components.widgets.basicWidgets.icon",
          "apiDocLink": "classes/Icon.html",
          "widgetDocLink": "basic/icon",
          "keywords": "icon",
          "dropEffectCls": "wm-icon inline"
        },
        {
          "widgetType": "wm-picture",
          "name": "Picture",
          "namekey": "LABEL_WIDGET_PICTURE",
          "iconclass": "picture",
          "feature": "components.widgets.basicWidgets.picture",
          "apiDocLink": "classes/Picture.html",
          "widgetDocLink": "basic/picture",
          "keywords": "picture",
          "dropEffectCls": "wm-picture inline"
        },
        {
          "widgetType": "wm-tree",
          "name": "Tree",
          "namekey": "LABEL_WIDGET_TREE",
          "iconclass": "tree",
          "feature": "components.widgets.basicWidgets.tree",
          "apiDocLink": "classes/Tree.html",
          "widgetDocLink": "basic/tree",
          "keywords": "tree",
          "dropEffectCls": "wm-tree block"
        },
        {
          "widgetType": "wm-lottie",
          "name": "Lottie",
          "namekey": "LABEL_WIDGET_LOTTIE",
          "iconclass": "lottie",
          "feature": "components.widgets.basicWidgets.lottie",
          "apiDocLink": "classes/Lottie.html",
          "widgetDocLink": "basic/lottie",
          "keywords": "lottie",
          "dropEffectCls": "wm-lottie block"
        },
        {
          "widgetType": "wm-video",
          "name": "Video",
          "namekey": "LABEL_WIDGET_VIDEO",
          "iconclass": "video",
          "feature": "components.widgets.basicWidgets.video",
          "apiDocLink": "classes/Video.html",
          "widgetDocLink": "basic/video",
          "keywords": "video",
          "dropEffectCls": "wm-video inline"
        },
        {
          "widgetType": "wm-audio",
          "name": "Audio",
          "namekey": "LABEL_WIDGET_AUDIO",
          "iconclass": "audio",
          "feature": "components.widgets.basicWidgets.audio",
          "apiDocLink": "classes/Audio.html",
          "widgetDocLink": "basic/audio",
          "keywords": "audio",
          "dropEffectCls": "wm-audio inline"
        },
        {
          "widgetType": "wm-html",
          "name": "html",
          "namekey": "LABEL_WIDGET_HTML",
          "iconclass": "html",
          "feature": "components.widgets.basicWidgets.html",
          "apiDocLink": "classes/Html.html",
          "widgetDocLink": "basic/html",
          "keywords": "html",
          "dropEffectCls": "wm-html block"
        },
        {
          "widgetType": "wm-iframe",
          "name": "iframe",
          "namekey": "LABEL_WIDGET_IFRAME",
          "iconclass": "iframe",
          "feature": "components.widgets.basicWidgets.iframe",
          "apiDocLink": "classes/Iframe.html",
          "widgetDocLink": "basic/iframe",
          "keywords": "iframe",
          "dropEffectCls": "wm-iframe inline"
        },
        {
          "widgetType": "wm-webview",
          "name": "webview",
          "namekey": "LABEL_WIDGET_WEBVIEW",
          "iconclass": "iframe",
          "feature": "components.widgets.basicWidgets.webview",
          "apiDocLink": "classes/webview.html",
          "widgetDocLink": "basic/webview",
          "keywords": "webview",
          "dropEffectCls": "wm-webview inline"
        },
        {
          "widgetType": "wm-message",
          "name": "Message",
          "namekey": "LABEL_WIDGET_MESSAGE",
          "iconclass": "message",
          "feature": "components.widgets.basicWidgets.message",
          "apiDocLink": "classes/Message.html",
          "widgetDocLink": "basic/message",
          "keywords": "message",
          "dropEffectCls": "wm-message block"
        },
        {
          "widgetType": "wm-spinner",
          "name": "Spinner",
          "namekey": "LABEL_WIDGET_SPINNER",
          "iconclass": "spinner",
          "feature": "components.widgets.basicWidgets.spinner",
          "apiDocLink": "classes/Spinner.html",
          "widgetDocLink": "basic/spinner",
          "keywords": "spinner",
          "dropEffectCls": "wm-spinner block"
        },
        {
          "widgetType": "wm-search",
          "name": "Search",
          "namekey": "LABEL_WIDGET_SEARCH",
          "iconclass": "search",
          "feature": "components.widgets.basicWidgets.search",
          "apiDocLink": "classes/Search.html",
          "widgetDocLink": "basic/search",
          "keywords": "search",
          "dropEffectCls": "wm-search block"
        },
        {
          "widgetType": "wm-richtexteditor",
          "name": "Richtext editor",
          "namekey": "LABEL_WIDGET_RICHTEXTEDITOR",
          "iconclass": "richtexteditor",
          "feature": "components.widgets.basicWidgets.richTextEditor",
          "apiDocLink": "classes/RichTextEditor.html",
          "widgetDocLink": "basic/richtext-editor",
          "keywords": "richtexteditor, rich text editor",
          "dropEffectCls": "wm-richtexteditor block"
        },
        {
          "widgetType": "wm-progress-bar",
          "name": "Progress bar",
          "namekey": "LABEL_WIDGET_PROGRESS_BAR",
          "iconclass": "progress",
          "feature": "components.widgets.basicWidgets.progressBar",
          "apiDocLink": "classes/ProgressBar.html",
          "widgetDocLink": "basic/progress-bar",
          "keywords": "progress-bar",
          "dropEffectCls": "wm-progress-bar block"
        },
        {
          "widgetType": "wm-progress-circle",
          "name": "Progress Circle",
          "namekey": "LABEL_WIDGET_PROGRESS_CIRCLE",
          "iconclass": "progress-circle",
          "feature": "components.widgets.basicWidgets.progressCircle",
          "apiDocLink": "classes/CircleProgressBar.html",
          "widgetDocLink": "basic/progress-circle",
          "keywords": "progress,progress circle,radial",
          "dropEffectCls": "wm-progress-circle block"
        }
      ]
    }
  );

  /* Add the list to the list subGroup. */
  wpProvider.addSubGroup(
    {
      "name": "livewidgets",
      "namekey": "LABEL_LIVE_WIDGETS",
      "parent": "widgets",
      "feature": "components.widgets.liveWidgets",
      "widgets": [
        {
          "widgetType": "wm-table",
          "name": "Data Table",
          "namekey": "LABEL_WIDGET_TABLE",
          "iconclass": "table",
          "keywords": "Data Table, Data Grid, Datagrid, Grid, Table",
          "feature": "components.widgets.tables.table",
          "apiDocLink": "classes/Table.html",
          "widgetDocLink": "datalive/data-table",
          "dropEffectCls": "wm-table block"
        },
        {
          "widgetType": "wm-form",
          "name": "Form",
          "namekey": "LABEL_WIDGET_FORM",
          "iconclass": "form",
          "keywords": "form",
          "feature": "components.layouts.container.form",
          "apiDocLink": "classes/Form.html",
          "widgetDocLink": "datalive/form",
          "dropEffectCls": "wm-form block"
        },
        {
          "widgetType": "wm-list",
          "name": "List",
          "namekey": "LABEL_WIDGET_LIST",
          "iconclass": "list",
          "keywords": "List, Live List, Livelist",
          "feature": "components.widgets.liveWidgets.list",
          "apiDocLink": "classes/List.html",
          "widgetDocLink": "datalive/list",
          "dropEffectCls": "wm-list block"
        },
        {
          "widgetType": "wm-card",
          "name": "Cards",
          "namekey": "LABEL_WIDGET_CARD",
          "iconclass": "card",
          "feature": "components.layouts.container.card",
          "keywords": "Card",
          "apiDocLink": "classes/Card.html",
          "widgetDocLink": "datalive/cards",
          "dropEffectCls": "wm-card block"
        },
        {
          "widgetType": "wm-liveform",
          "name": "Live Form",
          "namekey": "LABEL_WIDGET_LIVEFORM",
          "iconclass": "liveform",
          "feature": "components.widgets.liveWidgets.liveForm",
          "keywords": "Live, Live Form, Liveform",
          "apiDocLink": "classes/LiveForm.html",
          "widgetDocLink": "datalive/live-form",
          "dropEffectCls": "wm-liveform block"
        },
        {
          "widgetType": "wm-livefilter",
          "name": "Live Filter",
          "namekey": "LABEL_WIDGET_LIVEFILTER",
          "iconclass": "livefilter",
          "feature": "components.widgets.liveWidgets.liveFilter",
          "keywords": "Live, Live Filter, Livefilter",
          "apiDocLink": "classes/LiveFilter.html",
          "widgetDocLink": "datalive/live-filter",
          "dropEffectCls": "wm-livefilter block"
        }
      ]
    }
  );

  /* Add the charts to the chart subGroup. */
  wpProvider.addSubGroup(
    {
      "name": "charts",
      "namekey": "LABEL_WIDGETS_CHARTS",
      "parent": "widgets",
      "feature": "components.widgets.charts",
      "widgets": [
        {
          "widgetType": "wm-chart-line",
          "name": "Line",
          "namekey": "LABEL_WIDGET_LINECHART",
          "iconclass": "linechart",
          "feature": "components.widgets.charts.lineChart",
          "keywords": "line, line chart, linechart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#line",
          "dropEffectCls": "wm-chart-line block"
        },
        {
          "widgetType": "wm-chart-column",
          "name": "Column",
          "namekey": "LABEL_WIDGET_COLUMNCHART",
          "iconclass": "columnchart",
          "feature": "components.widgets.charts.columnChart",
          "keywords": "column, column chart, columnchart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#column",
          "dropEffectCls": "wm-chart-column block"
        },
        {
          "widgetType": "wm-chart-area",
          "name": "Area",
          "namekey": "LABEL_WIDGET_AREACHART",
          "iconclass": "areachart",
          "feature": "components.widgets.charts.areaChart",
          "keywords": "area, area chart, areachart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#area",
          "dropEffectCls": "wm-chart-area block"
        },
        {
          "widgetType": "wm-chart-pie",
          "name": "Pie",
          "namekey": "LABEL_WIDGET_PIECHART",
          "iconclass": "piechart",
          "feature": "components.widgets.charts.pieChart",
          "keywords": "pie, pie chart, piechart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#pie",
          "dropEffectCls": "wm-chart-pie block"
        },
        {
          "widgetType": "wm-chart-bar",
          "name": "Bar",
          "namekey": "LABEL_WIDGET_BARCHART",
          "iconclass": "barchart",
          "feature": "components.widgets.charts.barChart",
          "keywords": "bar, bar chart, barchart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#bar",
          "dropEffectCls": "wm-chart-bar block"
        },
        {
          "widgetType": "wm-chart-cumulativeline",
          "name": "Cumulative line",
          "namekey": "LABEL_WIDGET_CUMULATIVELINECHART",
          "iconclass": "cumulativelinechart",
          "feature": "components.widgets.charts.cumulativeLineChart",
          "keywords": "cumulativeline, cumulativeline chart, cumulativelinechart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#line",
          "dropEffectCls": "wm-chart-cumulativeline block"
        },
        {
          "widgetType": "wm-chart-donut",
          "name": "Donut",
          "namekey": "LABEL_WIDGET_DONUTCHART",
          "iconclass": "donutchart",
          "feature": "components.widgets.charts.donutChart",
          "keywords": "donut, donut chart, donutchart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#donut",
          "dropEffectCls": "wm-chart-donut block"
        },
        {
          "widgetType": "wm-chart-bubble",
          "name": "Bubble",
          "namekey": "LABEL_WIDGET_BUBBLECHART",
          "iconclass": "bubblechart",
          "feature": "components.widgets.charts.bubbleChart",
          "keywords": "bubble, bubble chart, bubblechart, chart",
          "apiDocLink": "classes/Chart.html",
          "widgetDocLink": "chart/chart-widget/#bubble",
          "dropEffectCls": "wm-chart-bubble block"
        }
      ]
    }
  );

  /* Add the list to the list subGroup. */
  wpProvider.addSubGroup(
    {
      "name": "advancedwidgets",
      "namekey": "LABEL_ADVANCED_WIDGETS",
      "parent": "widgets",
      "feature": "components.widgets.advancedWidgets",
      "widgets": [
        {
          "widgetType": "wm-login",
          "name": "Login",
          "namekey": "LABEL_WIDGET_LOGIN",
          "iconclass": "login",
          "feature": "components.widgets.advancedWidgets.login",
          "keywords": "advanced, login, login widget",
          "apiDocLink": "classes/Login.html",
          "widgetDocLink": "advanced/login",
          "dropEffectCls": "wm-login block"
        },
        {
          "widgetType": "wm-marquee",
          "name": "Marquee",
          "namekey": "LABEL_WIDGET_MARQUEE",
          "iconclass": "marquee",
          "feature": "components.widgets.advancedWidgets.marquee",
          "keywords": "advanced, marquee",
          "apiDocLink": "classes/Marquee.html",
          "widgetDocLink": "advanced/marquee",
          "dropEffectCls": "wm-marquee block"
        },
        {
          "widgetType": "wm-custom",
          "name": "Custom",
          "namekey": "LABEL_WIDGET_CUSTOM",
          "iconclass": "html",
          "feature": "components.widgets.advancedWidgets.custom",
          "keywords": "advanced, custom",
          "apiDocLink": "classes/custom.html",
          "widgetDocLink": "advanced/custom",
          "dropEffectCls": "wm-custom block"
        },
        {
          "widgetType": "wm-carousel",
          "name": "carousel",
          "namekey": "LABEL_WIDGET_CAROUSEL",
          "iconclass": "carousel",
          "feature": "components.widgets.advancedWidgets.carousel",
          "keywords": "advanced, carousel",
          "apiDocLink": "classes/Carousel.html",
          "widgetDocLink": "advanced/carousel",
          "dropEffectCls": "wm-carousel block"
        }
      ]
    }
  );

  /* Add the dialog to the dialogs subGroup. */
  wpProvider.addSubGroup(
    {
      "name": "dialogs",
      "namekey": "LABEL_WIDGETS_DIALOGS",
      "parent": "widgets",
      "feature": "components.widgets.dialogs",
      "widgets": [
        {
          "widgetType": "wm-design-dialog",
          "name": "Design Dialog",
          "namekey": "LABEL_WIDGET_DESIGN_DIALOG",
          "iconclass": "design-dialog",
          "feature": "components.widgets.dialogs.designDialog",
          "keywords": "design, design dialog, designdialog, dialog",
          "apiDocLink": "classes/Designdialog.html",
          "widgetDocLink": "modal-windows-dialogs/#design-dialog",
          "dropEffectCls": "wm-design-dialog block"
        },
        {
          "widgetType": "wm-alertdialog",
          "name": "Alert Dialog",
          "namekey": "LABEL_WIDGET_ALERT_DIALOG",
          "iconclass": "alert-dialog",
          "feature": "components.widgets.dialogs.alertDialog",
          "keywords": "alert, alert dialog, alertdialog, dialog",
          "apiDocLink": "classes/Alertdialog.html",
          "widgetDocLink": "modal-windows-dialogs/#alert-dialog",
          "dropEffectCls": "wm-alertdialog block"
        },
        {
          "widgetType": "wm-confirmdialog",
          "name": "Confirm Dialog",
          "namekey": "LABEL_WIDGET_CONFIRM_DIALOG",
          "iconclass": "confirm-dialog",
          "feature": "components.widgets.dialogs.confirmDialog",
          "keywords": "confirm, confirm dialog, confirmdialog, dialog",
          "apiDocLink": "classes/Confirmdialog.html",
          "widgetDocLink": "modal-windows-dialogs/#confirm-dialog",
          "dropEffectCls": "wm-confirmdialog block"
        },
        {
          "widgetType": "wm-iframedialog",
          "name": "Iframe Dialog",
          "namekey": "LABEL_WIDGET_IFRAME_DIALOG",
          "iconclass": "iframe-dialog",
          "feature": "components.widgets.dialogs.iFrameDialog",
          "keywords": "iframe, iframe dialog, iframedialog, dialog",
          "apiDocLink": "classes/IFramedialog.html",
          "widgetDocLink": "modal-windows-dialogs/#iframe-dialog",
          "dropEffectCls": "wm-iframedialog block"
        },
        {
          "widgetType": "wm-pagedialog",
          "name": "Page Dialog",
          "namekey": "LABEL_WIDGET_PAGE_DIALOG",
          "iconclass": "page-dialog",
          "feature": "components.widgets.dialogs.pageDialog",
          "keywords": "page, page dialog, pagedialog, dialog",
          "apiDocLink": "classes/Pagedialog.html",
          "widgetDocLink": "modal-windows-dialogs/#page-dialog",
          "dropEffectCls": "wm-pagedialog block"
        },
        {
          "widgetType": "wm-logindialog",
          "name": "Login Dialog",
          "namekey": "LABEL_WIDGET_LOGIN_DIALOG",
          "iconclass": "login-dialog",
          "feature": "components.widgets.dialogs.loginDialog",
          "keywords": "login, login dialog, logindialog, dialog",
          "apiDocLink": "classes/Logindialog.html",
          "widgetDocLink": "modal-windows-dialogs/#login-dialog",
          "dropEffectCls": "wm-logindialog block"
        }
      ]
    }
  );

  wpProvider.addGroup({
    "name": "prefabs",
    "namekey": "LABEL_PREFABS",
    "iconclass": "prefab",
    "feature": "components.prefabs"
  });
  wpProvider.addSubGroup({
    "name": "prefabssubgroup",
    "namekey": "LABEL_PREFABS",
    "parent": "prefabs",
    "widgets": []
  });

  forEach(containerSubGroup, (value: any) => {
    wpProvider.addSubGroup(value)
  }
  )
  forEach(deviceSubGroup, (value: any) => {
      wpProvider.addSubGroup(value)
    }
  )
}
